import React, { useEffect, useMemo, useState } from "react";
import {
  FaBell,
  FaCheckCircle,
  FaComments,
  FaPen,
  FaClipboardList,
  FaTimes,
  FaSearch,
  FaUndoAlt,
  FaBan,
  FaCopy,
  FaChevronUp,
  FaChevronDown,
  FaFilter,
  FaSyncAlt,
  FaExclamationTriangle,
  FaHistory,
  FaFileAlt,
  FaFileSignature,
  FaHourglassHalf,
  FaUserCheck,
  FaCreditCard,
  FaHandshake,
  FaArchive,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const GRID_STORAGE_ID = "central-interacao";
const GRID_STORAGE_VERSION = 5;

/*
 * Opções oficiais do filtro PROCESSO.
 * Não dependem das pendências atualmente carregadas.
 */
const PROCESSOS_DISPONIVEIS = ["Proposta Comercial", "Ficha Cadastro", "Análise de Crédito", "Contrato", "Template de Contrato", "Assinatura Final"];

/*
 * Situações visuais oficiais da Central do ImobGest.
 * Também não dependem dos registros atualmente carregados.
 */
const SITUACOES_DISPONIVEIS = ["Novo", "Visto", "Questionamento", "Respondido", "Revisão", "Reprovado / Devolvido", "Assinatura"];

/*
 * Situações disponíveis exclusivamente
 * em HISTÓRICOS.
 */
const SITUACOES_HISTORICOS = ["Aprovado", "Reprovado", "Questionado", "Respondido", "Revisado", "Assinado"];

const SITUACOES_ASSINATURAS = ["Pendente", "Aguardando", "Assinado", "Recusado"];

const DASHBOARD_ESTEIRAS = [
  {
    chave: "PROPOSTA",
    titulo: "PROPOSTA COMERCIAL",
    etapas: [
      {
        chave: "EM_DIGITACAO",
        titulo: "EM DIGITAÇÃO",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaPen,
      },
      {
        chave: "EM_APROVACAO",
        titulo: "EM APROVAÇÃO",
        cor: "#19bfe5",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "COM_PENDENCIA",
        titulo: "COM PENDÊNCIA",
        cor: "#b52c2c",
        texto: "#ffffff",
        Icone: FaExclamationTriangle,
      },
      {
        chave: "APROVADA",
        titulo: "APROVADA",
        cor: "#ff3b7f",
        texto: "#ffffff",
        Icone: FaCheckCircle,
      },
      {
        chave: "ASSINATURA_RASCUNHO",
        titulo: "ASS. EM RASCUNHO",
        cor: "#ffa726",
        texto: "#ffffff",
        Icone: FaFileSignature,
      },
      {
        chave: "EM_ASSINATURA",
        titulo: "EM ASSINATURA",
        cor: "#2889df",
        texto: "#ffffff",
        Icone: FaPen,
      },
      {
        chave: "ASSINADA",
        titulo: "ASSINADA",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaHandshake,
      },
    ],
  },

  {
    chave: "FICHA",
    titulo: "FICHA DE CADASTRO",
    etapas: [
      {
        chave: "EM_DIGITACAO",
        titulo: "EM DIGITAÇÃO",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaFileAlt,
      },
      {
        chave: "EM_APROVACAO",
        titulo: "EM APROVAÇÃO",
        cor: "#19bfe5",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "APROVADA",
        titulo: "APROVADA",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaUserCheck,
      },
    ],
  },

  {
    chave: "ANALISE",
    titulo: "ANÁLISE DE CRÉDITO",
    etapas: [
      {
        chave: "EM_DIGITACAO",
        titulo: "EM DIGITAÇÃO",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaCreditCard,
      },
      {
        chave: "EM_APROVACAO",
        titulo: "EM APROVAÇÃO",
        cor: "#19bfe5",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "APROVADA",
        titulo: "APROVADA",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaCheckCircle,
      },
    ],
  },

  {
    chave: "CONTRATO",
    titulo: "CONTRATO",
    etapas: [
      {
        chave: "EM_DIGITACAO",
        titulo: "EM DIGITAÇÃO",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaFileAlt,
      },
      {
        chave: "EM_APROVACAO",
        titulo: "EM APROVAÇÃO",
        cor: "#19bfe5",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "APROVADA",
        titulo: "APROVADA",
        cor: "#ff3b7f",
        texto: "#ffffff",
        Icone: FaCheckCircle,
      },
      {
        chave: "ASSINATURA_RASCUNHO",
        titulo: "ASS. EM RASCUNHO",
        cor: "#ffa726",
        texto: "#ffffff",
        Icone: FaFileSignature,
      },
      {
        chave: "EM_ASSINATURA",
        titulo: "EM ASSINATURA",
        cor: "#2889df",
        texto: "#ffffff",
        Icone: FaPen,
      },
      {
        chave: "ASSINADA",
        titulo: "ASSINADA",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaHandshake,
      },
    ],
  },
  {
    chave: "TEMPLATE",
    titulo: "TEMPLATE DE CONTRATO",
    etapas: [
      {
        chave: "EM_DIGITACAO",
        titulo: "EM ELABORAÇÃO",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaFileAlt,
      },
      {
        chave: "EM_APROVACAO",
        titulo: "EM APROVAÇÃO",
        cor: "#19bfe5",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "APROVADA",
        titulo: "APROVADO",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaCheckCircle,
      },
    ],
  },
  {
    chave: "ASSINATURAS",
    titulo: "ASSINATURAS",
    etapas: [
      {
        chave: "PENDENTE",
        titulo: "PENDENTE",
        cor: "#ffb347",
        texto: "#111827",
        Icone: FaHourglassHalf,
      },
      {
        chave: "AGUARDANDO",
        titulo: "AGUARDANDO",
        cor: "#2889df",
        texto: "#ffffff",
        Icone: FaHourglassHalf,
      },
      {
        chave: "ASSINADO",
        titulo: "ASSINADO",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaHandshake,
      },
      {
        chave: "RECUSADO",
        titulo: "RECUSADO",
        cor: "#e53935",
        texto: "#ffffff",
        Icone: FaBan,
      },
    ],
  },
  {
    chave: "GERAL",
    titulo: "STATUS GERAIS",
    etapas: [
      {
        chave: "REPROVADA",
        titulo: "REPROVADA",
        cor: "#e53935",
        texto: "#ffffff",
        Icone: FaBan,
      },
      {
        chave: "INUTILIZADA",
        titulo: "INUTILIZADA",
        cor: "#795548",
        texto: "#ffffff",
        Icone: FaArchive,
      },
      {
        chave: "ASSINATURA_CANCELADA",
        titulo: "ASSINATURA CANCELADA",
        cor: "#9c1760",
        texto: "#ffffff",
        Icone: FaTimes,
      },
      {
        chave: "CONCLUIDA",
        titulo: "CONCLUÍDA",
        cor: "#218c5a",
        texto: "#ffffff",
        Icone: FaCheckCircle,
      },
    ],
  },
];

const LEGENDA_SITUACOES = [
  {
    nome: "Novo",
    classe: "border border-[color:var(--ig-b-6b7280)] bg-transparent",
  },
  {
    nome: "Visto",
    classe: "border border-[#eab308] bg-[#eab308]",
  },
  {
    nome: "Questionamento",
    classe: "border border-[#a855f7] bg-[#a855f7]",
  },
  {
    nome: "Respondido",
    classe: "border border-[#2196f3] bg-[#2196f3]",
  },
  {
    nome: "Revisão",
    classe: "border border-[#f97316] bg-[#f97316]",
  },
  {
    nome: "Reprovado / Devolvido",
    classe: "border border-[#ef4444] bg-[#ef4444]",
  },
  {
    nome: "Assinatura",
    classe: "border border-[#06b6d4] bg-[#06b6d4]",
  },
];

/*
 * Larguras compactas.
 *
 * O objetivo é que a grade caiba normalmente na tela.
 * A barra horizontal só aparece se o usuário aumentar
 * manualmente alguma coluna.
 */
const COLUNAS_CENTRAL = [
  {
    chave: "SITUACAO",
    titulo: "Situação",
    largura: 110,
    min: 105,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "TIPO",
    titulo: "Tipo",
    largura: 190,
    min: 180,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "PROCESSO",
    titulo: "Processo",
    largura: 150,
    min: 140,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "CODIGO",
    titulo: "Código",
    largura: 92,
    min: 82,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "DESCRICAO",
    titulo: "Descrição",
    largura: 245,
    min: 190,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "SOLICITANTE",
    titulo: "Solicitante",
    largura: 125,
    min: 105,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "NA_VEZ_DE",
    titulo: "Na vez de",
    largura: 115,
    min: 100,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "IMOVEL_LOCATARIO",
    titulo: "Imóvel / Locatário",
    largura: 150,
    min: 135,
    ordenavel: true,
    filtravel: true,
  },
  {
    chave: "ATUALIZADO",
    titulo: "Atualizado",
    largura: 190,
    min: 180,
    ordenavel: true,
    filtravel: true,
  },
];

const COLUNAS_CENTRAL_MAPA = COLUNAS_CENTRAL.reduce((mapa, coluna) => {
  mapa[coluna.chave] = coluna;
  return mapa;
}, {});

const FILTROS_COLUNA_VAZIOS = {
  SITUACAO: "",
  TIPO: "",
  PROCESSO: "",
  CODIGO: "",
  DESCRICAO: "",
  SOLICITANTE: "",
  NA_VEZ_DE: "",
  IMOVEL_LOCATARIO: "",
  ATUALIZADO: "",
};

const criarConfiguracaoPadraoGrid = () => ({
  versao: GRID_STORAGE_VERSION,

  ordem: COLUNAS_CENTRAL.map((coluna) => coluna.chave),

  larguras: COLUNAS_CENTRAL.reduce((mapa, coluna) => {
    mapa[coluna.chave] = coluna.largura;
    return mapa;
  }, {}),
});

const carregarConfiguracaoGrid = () => {
  const padrao = criarConfiguracaoPadraoGrid();

  if (typeof window === "undefined") {
    return padrao;
  }

  try {
    const salvo = window.localStorage.getItem(GRID_STORAGE_ID);

    if (!salvo) {
      return padrao;
    }

    const configuracaoSalva = JSON.parse(salvo);

    /*
     * Importante:
     * invalida a configuração antiga, que guardou as
     * larguras excessivas da versão anterior.
     */
    if (configuracaoSalva?.versao !== GRID_STORAGE_VERSION) {
      return padrao;
    }

    const ordemSalva = Array.isArray(configuracaoSalva?.ordem) ? configuracaoSalva.ordem.filter((chave) => COLUNAS_CENTRAL_MAPA[chave]) : [];

    const colunasFaltantes = padrao.ordem.filter((chave) => !ordemSalva.includes(chave));

    const larguras = {
      ...padrao.larguras,
    };

    COLUNAS_CENTRAL.forEach((coluna) => {
      const larguraSalva = Number(configuracaoSalva?.larguras?.[coluna.chave]);

      if (Number.isFinite(larguraSalva)) {
        larguras[coluna.chave] = Math.max(coluna.min, larguraSalva);
      }
    });

    return {
      versao: GRID_STORAGE_VERSION,
      ordem: [...ordemSalva, ...colunasFaltantes],
      larguras,
    };
  } catch (err) {
    console.error("Central de Interação: erro ao carregar configuração da grid.", err);

    return padrao;
  }
};

function FiltroSelect({ rotulo, valor, placeholder, opcoes, onChange, className = "w-[250px]" }) {
  const [aberto, setAberto] = useState(false);
  const [focado, setFocado] = useState(false);

  return (
    <div
      className={`relative ${className}`}
      onFocus={() => setFocado(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setFocado(false);
          setAberto(false);
        }
      }}
    >
      <fieldset
        className={`
          h-[46px]
          w-full
          px-3
          rounded-md
          border
          bg-[color:var(--ig-f-111625)]
          transition-colors
          ${focado || aberto ? "border-[#2196f3]" : "border-[color:var(--ig-b-4b5568)]"}
        `}
      >
        <legend
          className={`
            px-1
            text-[11px]
            leading-none
            transition-colors
            ${focado || aberto ? "text-[#2196f3]" : "text-[color:var(--ig-t-d1d5db)]"}
          `}
        >
          {rotulo}
        </legend>

        <button
          type="button"
          onClick={() => {
            setAberto((estadoAtual) => !estadoAtual);
            setFocado(true);
          }}
          className="
            w-full
            h-[30px]
            -mt-[1px]
            flex
            items-center
            justify-between
            gap-3
            bg-transparent
            text-left
            text-[color:var(--ig-t-e5e7eb)]
            text-sm
            outline-none
          "
        >
          <span className="truncate">{valor || placeholder}</span>

          <FaChevronDown
            size={12}
            className={`
              flex-shrink-0
              transition-transform
              ${aberto ? "rotate-180 text-[color:var(--ig-t-ffffff)]" : "text-[color:var(--ig-t-d1d5db)]"}
            `}
          />
        </button>
      </fieldset>

      {aberto && (
        <div
          className="
            absolute
            z-[120]
            top-[49px]
            left-0
            w-full
            max-h-[300px]
            overflow-y-auto
            rounded-b-md
            border
            border-[color:var(--ig-b-3d4658)]
            bg-[color:var(--ig-f-2b2b2b)]
            shadow-xl
          "
        >
          <button
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => {
              onChange("");
              setAberto(false);
              setFocado(false);
            }}
            className={`
              w-full
              min-h-[43px]
              px-5
              flex
              items-center
              text-left
              text-sm
              transition-colors
              ${!valor ? "bg-[#294154] text-white" : "bg-[color:var(--ig-f-2b2b2b)] text-[color:var(--ig-t-f3f4f6)] hover:bg-[color:var(--ig-f-363636)]"}
            `}
          >
            {placeholder}
          </button>

          {opcoes.map((opcao) => (
            <button
              key={opcao}
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                onChange(opcao);
                setAberto(false);
                setFocado(false);
              }}
              className={`
                w-full
                min-h-[43px]
                px-5
                flex
                items-center
                text-left
                text-sm
                transition-colors
                ${valor === opcao ? "bg-[#294154] text-white" : "bg-[color:var(--ig-f-2b2b2b)] text-[color:var(--ig-t-f3f4f6)] hover:bg-[color:var(--ig-f-363636)]"}
              `}
            >
              {opcao}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function DashboardEsteira({ titulo, etapas, onEtapaClick }) {
  return (
    <div className="mb-8">
      <h3 className="text-center text-[20px] font-bold text-[color:var(--ig-t-d1d5db)] mb-4">{titulo}</h3>

      <div className="w-full overflow-x-auto pb-2">
        <div className="flex items-stretch justify-center min-w-max px-2">
          {etapas.map((etapa, index) => {
            const Icone = etapa.Icone;

            return (
              <button
                type="button"
                key={`${titulo}-${etapa.chave}`}
                onClick={() => {
                  if (typeof onEtapaClick === "function") {
                    onEtapaClick(etapa);
                  }
                }}
                title={`Abrir ${titulo} - ${etapa.titulo}`}
                className={`
                  relative
                  min-w-[170px]
                  h-[105px]
                  flex
                  flex-col
                  items-center
                  justify-center
                  px-5
                  cursor-pointer
                  border-0
                  transition-all
                  duration-150
                  hover:brightness-110
                  hover:-translate-y-[2px]
                  focus:outline-none
                  focus:ring-2
                  focus:ring-white/50
                  ${index > 0 ? "-ml-[10px]" : ""}
                `}
                style={{
                  backgroundColor: etapa.cor,
                  color: etapa.texto,
                  clipPath: index === 0 ? "polygon(0 0, 88% 0, 100% 50%, 88% 100%, 0 100%)" : "polygon(0 0, 88% 0, 100% 50%, 88% 100%, 0 100%, 12% 50%)",
                }}
              >
                <span
                  className="
                    text-[11px]
                    font-extrabold
                    text-center
                    uppercase
                    leading-[14px]
                    min-h-[28px]
                    flex
                    items-center
                    justify-center
                  "
                >
                  {etapa.titulo}
                </span>

                <Icone size={19} className="mt-1 mb-1" />

                <span className="text-[28px] font-extrabold leading-none">{etapa.valor ?? 0}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function CentralInteracao({
  modo = "pagina",
  onFechar,
  pendencias: pendenciasRecebidas,
  loading: loadingRecebido,
  erro: erroRecebido,
  onAtualizar,
  onQuantidadeChange,
}) {
  const navigate = useNavigate();

  const modoOverlay = modo === "overlay";

  /*
   * =====================================================
   * BLOQUEAR ROLAGEM DA PÁGINA ATRÁS DO OVERLAY
   * =====================================================
   *
   * Quando Dashboard / Central estiver aberto no Header,
   * somente o próprio overlay deve possuir barra de rolagem.
   */
  useEffect(() => {
    if (!modoOverlay) {
      return undefined;
    }

    const overflowBodyAnterior = document.body.style.overflow;
    const overflowHtmlAnterior = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = overflowBodyAnterior;
      document.documentElement.style.overflow = overflowHtmlAnterior;
    };
  }, [modoOverlay]);

  /*
   * =====================================================
   * DADOS
   * =====================================================
   */

  const [pendenciasInternas, setPendenciasInternas] = useState([]);

  const [propostasDashboard, setPropostasDashboard] = useState([]);

  // Templates de contrato (esteira própria + Status Gerais).
  const [templatesDashboard, setTemplatesDashboard] = useState([]);

  // "Na vez de" do detalhamento do Dashboard (quem precisa agir em cada processo).
  const [naVezDeDashboard, setNaVezDeDashboard] = useState({});
  const [assinaturasParticipantes, setAssinaturasParticipantes] = useState([]);

  /*
   * =====================================================
   * APROVADORES - DASHBOARD ADMINISTRATIVO
   * =====================================================
   */

  const [usuariosAprovadoresDashboard, setUsuariosAprovadoresDashboard] = useState([]);

  const [loadingAprovadoresDashboard, setLoadingAprovadoresDashboard] = useState(false);

  /*
   * =====================================================
   * PAGINAÇÃO - ATIVIDADE DE APROVADORES
   * =====================================================
   *
   * A paginação é feita por USUÁRIO.
   *
   * Dessa forma, todas as ações paradas de um mesmo
   * aprovador permanecem juntas na mesma página.
   * =====================================================
   */

  const [paginaAprovadores, setPaginaAprovadores] = useState(1);

  const [aprovadoresPorPagina, setAprovadoresPorPagina] = useState(5);

  const [seletorAprovadoresPaginaAberto, setSeletorAprovadoresPaginaAberto] = useState(false);

  const totalAprovadores = usuariosAprovadoresDashboard.length;

  const totalPaginasAprovadores = Math.max(1, Math.ceil(totalAprovadores / aprovadoresPorPagina));

  const paginaAprovadoresSegura = Math.min(paginaAprovadores, totalPaginasAprovadores);

  const indiceInicialAprovadores = totalAprovadores === 0 ? 0 : (paginaAprovadoresSegura - 1) * aprovadoresPorPagina;

  const indiceFinalAprovadores = Math.min(indiceInicialAprovadores + aprovadoresPorPagina, totalAprovadores);

  const usuariosAprovadoresPaginados = usuariosAprovadoresDashboard.slice(indiceInicialAprovadores, indiceFinalAprovadores);

  useEffect(() => {
    if (paginaAprovadores > totalPaginasAprovadores) {
      setPaginaAprovadores(totalPaginasAprovadores);
    }
  }, [paginaAprovadores, totalPaginasAprovadores]);

  const registrosAssinaturasCentral = assinaturasParticipantes;

  const [filtroDashboardSelecionado, setFiltroDashboardSelecionado] = useState(null);

  /*
   * Esta lista será preenchida pelo backend definitivo.
   *
   * Por enquanto permanece vazia caso a API atual
   * não devolva "acoesRealizadas".
   */
  const [acoesRealizadasInternas, setAcoesRealizadasInternas] = useState([]);

  const [loadingInterno, setLoadingInterno] = useState(false);
  const [erroCarregamento, setErroCarregamento] = useState("");

  const usandoDadosExternos = Array.isArray(pendenciasRecebidas);

  const pendencias = usandoDadosExternos ? pendenciasRecebidas : pendenciasInternas;

  /*
   * =====================================================
   * VISÃO PRINCIPAL
   * =====================================================
   */

  const [visaoSelecionada, setVisaoSelecionada] = useState("PENDENCIAS");

  /*
   * =====================================================
   * FONTE DA VISÃO ATUAL
   * =====================================================
   */

  const registrosVisaoAtual =
    visaoSelecionada === "HISTORICOS" ? acoesRealizadasInternas : visaoSelecionada === "ASSINATURAS" ? registrosAssinaturasCentral : pendencias;

  const loading = typeof loadingRecebido === "boolean" ? loadingRecebido : loadingInterno;

  const erro = usandoDadosExternos ? erroRecebido : erroCarregamento;

  const mensagemErro = typeof erro === "string" ? erro : erro?.message || (erro ? "Não foi possível carregar a Central de Interações." : "");

  /*
   * =====================================================
   * VISÃO PRINCIPAL / FILTROS / NAVEGAÇÃO
   * =====================================================
   */

  const [categoriaSelecionada, setCategoriaSelecionada] = useState("TODOS");

  const [filtroSituacao, setFiltroSituacao] = useState("");
  const [filtroProcesso, setFiltroProcesso] = useState("");
  const [filtroPesquisa, setFiltroPesquisa] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const [registrosExpandidos, setRegistrosExpandidos] = useState(true);

  /*
   * =====================================================
   * FILTROS INDIVIDUAIS DA GRID
   * =====================================================
   */

  const [filtrosColuna, setFiltrosColuna] = useState({
    ...FILTROS_COLUNA_VAZIOS,
  });

  const [filtroColunaAberto, setFiltroColunaAberto] = useState("");

  /*
   * =====================================================
   * CONFIGURAÇÃO / PERSISTÊNCIA DA GRID
   * =====================================================
   */

  const [configuracaoGrid, setConfiguracaoGrid] = useState(carregarConfiguracaoGrid);

  const [colunaArrastada, setColunaArrastada] = useState("");

  const ordemColunas = configuracaoGrid.ordem;
  const largurasColunas = configuracaoGrid.larguras;

  /*
   * =====================================================
   * ORDENAÇÃO
   * =====================================================
   */

  const [colunaOrdenacao, setColunaOrdenacao] = useState("ATUALIZADO");

  const [direcaoOrdenacao, setDirecaoOrdenacao] = useState("DESC");

  /*
   * =====================================================
   * PAGINAÇÃO
   * =====================================================
   */

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [registrosPorPagina, setRegistrosPorPagina] = useState(5);

  const [seletorPaginaAberto, setSeletorPaginaAberto] = useState(false);

  const [itensVisualizados, setItensVisualizados] = useState({});

  /*
   * =====================================================
   * TOKEN
   * =====================================================
   */

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("jwtToken") ||
      localStorage.getItem("jwt") ||
      localStorage.getItem("userToken")
    );
  };

  /*
   * =====================================================
   * PERFIL DO USUÁRIO
   * =====================================================
   */

  const tipoUsuarioAtual = useMemo(() => {
    const token = getToken();

    if (!token) {
      return "";
    }

    try {
      const decoded = jwtDecode(token);

      return String(decoded?.tipo || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    } catch (error) {
      console.error("Dashboard: não foi possível identificar o perfil do usuário.", error);

      return "";
    }
  }, []);

  const usuarioAdministrador = tipoUsuarioAtual === "administrador";

  /*
   * =====================================================
   * ATIVIDADE DE APROVADORES
   * =====================================================
   */

  useEffect(() => {
    if (!usuarioAdministrador) {
      setUsuariosAprovadoresDashboard([]);
      return;
    }

    const token = getToken();

    if (!token) {
      setUsuariosAprovadoresDashboard([]);
      return;
    }

    let componenteAtivo = true;

    const carregarAprovadores = async () => {
      try {
        setLoadingAprovadoresDashboard(true);

        const responseUsuarios = await fetch("/api/propostas/usuarios-aprovadores", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!responseUsuarios.ok) {
          throw new Error(`Erro ao carregar aprovadores. HTTP ${responseUsuarios.status}`);
        }

        const dadosUsuarios = await responseUsuarios.json();

        /*
         * Além dos aprovadores das alçadas, entram todos os usuários ativos:
         * assinaturas, questionamentos e etapas de Alterações Contratuais
         * podem ficar paradas com qualquer usuário.
         */
        let dadosAtivos = [];

        try {
          const responseAtivos = await fetch("/api/propostas/usuarios-ativos", {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          dadosAtivos = responseAtivos.ok ? await responseAtivos.json() : [];
        } catch {
          dadosAtivos = [];
        }

        const usuariosPorId = new Map();

        [...(Array.isArray(dadosUsuarios) ? dadosUsuarios : []), ...(Array.isArray(dadosAtivos) ? dadosAtivos : [])].forEach((usuario) => {
          const idUsuario = Number(usuario?.id ?? usuario?.usuarioId);

          if (Number.isInteger(idUsuario) && idUsuario > 0 && !usuariosPorId.has(idUsuario)) {
            usuariosPorId.set(idUsuario, usuario);
          }
        });

        const usuarios = [...usuariosPorId.values()];

        const usuariosComAtividade = await Promise.all(
          usuarios.map(async (usuario) => {
            const usuarioId = Number(usuario?.id ?? usuario?.usuarioId);

            if (!Number.isInteger(usuarioId) || usuarioId <= 0) {
              return {
                ...usuario,
                usuarioId,
                acoesParadas: [],
                ultimoAcesso: null,
              };
            }

            try {
              const responsePendencias = await fetch(`/api/pendencias-aprovacao?usuarioId=${usuarioId}`, {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });

              if (!responsePendencias.ok) {
                throw new Error(`HTTP ${responsePendencias.status}`);
              }

              const dadosPendencias = await responsePendencias.json();

              const pendenciasUsuario = Array.isArray(dadosPendencias?.pendencias) ? dadosPendencias.pendencias : [];

              const contagem = new Map();

              /*
               * TODAS as pendências do usuário: aprovações, questionamentos,
               * assinaturas e andamentos (Alterações Contratuais).
               * Agrupadas por processo + ação.
               */
              const nomesProcesso = {
                proposta: "PROPOSTA COMERCIAL",
                fichas: "FICHA DE CADASTRO",
                analisecredito: "ANÁLISE DE CRÉDITO",
                contrato: "CONTRATO",
                templatecontrato: "TEMPLATE DE CONTRATO",
                assinaturafinal: "ASSINATURA FINAL",
                assinatura: "ASSINATURA FINAL",
                alteracaocontratual: "ALTERAÇÃO CONTRATUAL",
              };

              const nomesAcao = {
                APROVAR: "Aprovação",
                RESPONDER: "Questionamento",
                ASSINAR: "Assinatura",
                AVANCAR: "Andamento",
                REVISAR: "Revisão",
              };

              for (const pendencia of pendenciasUsuario) {
                const processo = String(pendencia?.destino?.processoTipo || pendencia?.processoTipo || "")
                  .trim()
                  .toLowerCase();

                const nomeProcessoPendencia =
                  nomesProcesso[processo] ||
                  String(pendencia?.modulo || pendencia?.processoTipo || "OUTRAS")
                    .trim()
                    .toUpperCase();

                const acao =
                  nomesAcao[
                    String(pendencia?.tipo || "")
                      .trim()
                      .toUpperCase()
                  ] || "";

                const tipo = acao ? `${nomeProcessoPendencia} · ${acao}` : nomeProcessoPendencia;

                contagem.set(tipo, (contagem.get(tipo) || 0) + 1);
              }

              const acoesParadas = [...contagem.entries()]
                .map(([tipo, quantidade]) => ({
                  tipo,
                  quantidade,
                }))
                .sort((a, b) => a.tipo.localeCompare(b.tipo, "pt-BR"));

              return {
                ...usuario,
                usuarioId,
                acoesParadas,
                ultimoAcesso: dadosPendencias?.ultimoAcesso || null,
              };
            } catch (error) {
              console.error(`Dashboard: erro ao consultar pendências do aprovador ${usuarioId}.`, error);

              return {
                ...usuario,
                usuarioId,
                acoesParadas: [],
                ultimoAcesso: null,
              };
            }
          }),
        );

        if (!componenteAtivo) {
          return;
        }

        const totalPendencias = (usuario) => (usuario.acoesParadas || []).reduce((soma, acao) => soma + (Number(acao.quantidade) || 0), 0);

        usuariosComAtividade.sort((a, b) => totalPendencias(b) - totalPendencias(a) || String(a?.nome || "").localeCompare(String(b?.nome || ""), "pt-BR"));

        setUsuariosAprovadoresDashboard(usuariosComAtividade);
      } catch (error) {
        console.error("Dashboard: erro ao carregar aprovadores.", error);

        if (componenteAtivo) {
          setUsuariosAprovadoresDashboard([]);
        }
      } finally {
        if (componenteAtivo) {
          setLoadingAprovadoresDashboard(false);
        }
      }
    };

    carregarAprovadores();

    return () => {
      componenteAtivo = false;
    };
  }, [usuarioAdministrador]);

  useEffect(() => {
    const token = getToken();

    if (!token) {
      return;
    }

    const registrarAcessoHomeCentral = async () => {
      try {
        const response = await fetch("/api/pendencias-aprovacao/acesso-home", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Erro HTTP ${response.status}`);
        }
      } catch (error) {
        console.error("Central de Interação: não foi possível registrar o acesso à HOME / CENTRAL.", error);
      }
    };

    registrarAcessoHomeCentral();
  }, []);

  /*
   * =====================================================
   * DASHBOARD
   * =====================================================
   */

  const buscarDadosDashboard = async () => {
    const token = getToken();

    if (!token) {
      setPropostasDashboard([]);
      return;
    }

    try {
      const todos = [];
      let paginaDashboard = 0;
      let totalDashboard = 0;

      do {
        const params = new URLSearchParams({
          pagina: String(paginaDashboard),
          porPagina: "100",
          filtro: "",
        });

        const response = await fetch(`/api/propostas?${params.toString()}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Erro HTTP ${response.status}`);
        }

        const resultado = await response.json();

        const lote = Array.isArray(resultado?.data) ? resultado.data : [];

        todos.push(...lote);

        totalDashboard = Number(resultado?.total ?? todos.length);

        paginaDashboard += 1;

        if (lote.length === 0) {
          break;
        }
      } while (todos.length < totalDashboard);

      setPropostasDashboard(todos);
    } catch (error) {
      console.error("Central de Interação: erro ao carregar Dashboard.", error);

      setPropostasDashboard([]);
    }

    /*
     * TEMPLATES DE CONTRATO
     * Carga independente: uma falha aqui não afeta as demais esteiras.
     */
    try {
      const templates = [];
      let paginaTemplates = 0;
      let totalTemplates = 0;

      do {
        const params = new URLSearchParams({
          pagina: String(paginaTemplates),
          porPagina: "100",
          filtro: "",
        });

        const response = await fetch(`/api/templates?${params.toString()}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Erro HTTP ${response.status}`);
        }

        const resultado = await response.json();

        const lote = Array.isArray(resultado?.data) ? resultado.data : [];

        templates.push(...lote);

        totalTemplates = Number(resultado?.total ?? templates.length);

        paginaTemplates += 1;

        if (lote.length === 0) {
          break;
        }
      } while (templates.length < totalTemplates);

      setTemplatesDashboard(templates);
    } catch (error) {
      console.error("Central de Interação: erro ao carregar Templates de Contrato.", error);

      setTemplatesDashboard([]);
    }

    /*
     * "NA VEZ DE" (aprovador, respondente, assinante ou criador da vez)
     */
    try {
      const response = await fetch("/api/pendencias-aprovacao/na-vez-de", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }

      const resultado = await response.json();

      setNaVezDeDashboard(resultado?.porChave || {});
    } catch (error) {
      console.error("Central de Interação: erro ao carregar 'Na vez de'.", error);

      setNaVezDeDashboard({});
    }
  };

  /*
   * =====================================================
   * ASSINATURAS POR PARTICIPANTE
   * =====================================================
   */

  const buscarAssinaturasParticipantes = async () => {
    const token = getToken();

    if (!token) {
      setAssinaturasParticipantes([]);
      return;
    }

    try {
      const response = await fetch("/api/assinatura-final", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const resultado = await response.json();

      if (!response.ok) {
        throw new Error(resultado?.erro || `Erro HTTP ${response.status}`);
      }

      const processos = Array.isArray(resultado?.data) ? resultado.data : [];

      /*
       * Somente processos que efetivamente chegaram
       * ao fluxo de assinatura.
       */
      const processosDaEsteira = processos.filter((processo) =>
        ["ENVIADO", "AGUARDANDO_ASSINATURAS", "PARCIALMENTE_ASSINADO", "ASSINADO", "ARQUIVADO"].includes(
          String(processo?.statusFluxo || "")
            .trim()
            .toUpperCase(),
        ),
      );

      /*
       * A listagem geral de Assinatura Final não devolve
       * os participantes.
       *
       * Por isso consultamos o detalhe de cada processo
       * para obter nome, papel, e-mail e status individual.
       */
      const detalhes = await Promise.allSettled(
        processosDaEsteira.map(async (processo) => {
          const responseDetalhe = await fetch(`/api/assinatura-final/${processo.id}`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          const detalhe = await responseDetalhe.json();

          if (!responseDetalhe.ok) {
            throw new Error(detalhe?.erro || `Erro HTTP ${responseDetalhe.status}`);
          }

          return {
            processo: detalhe?.data?.processo || processo,
            participantes: Array.isArray(detalhe?.data?.participantes) ? detalhe.data.participantes : [],
          };
        }),
      );

      const registros = [];

      const statusPermitidos = ["PENDENTE", "AGUARDANDO", "ASSINADO", "RECUSADO"];

      detalhes.forEach((resultadoDetalhe) => {
        if (resultadoDetalhe.status !== "fulfilled") {
          console.error("Dashboard: erro ao carregar detalhes de uma assinatura.", resultadoDetalhe.reason);
          return;
        }

        const processo = resultadoDetalhe.value.processo || {};

        const participantes = resultadoDetalhe.value.participantes || [];

        participantes.forEach((participante) => {
          /*
           * assinadoEm possui prioridade.
           * Se houver data de assinatura, consideramos
           * o participante ASSINADO mesmo que o campo
           * status esteja desatualizado.
           */
          const statusParticipante = participante?.assinadoEm
            ? "ASSINADO"
            : String(participante?.status || "")
                .trim()
                .toUpperCase();

          if (!statusPermitidos.includes(statusParticipante)) {
            return;
          }

          const statusNome = {
            PENDENTE: "Pendente",
            AGUARDANDO: "Aguardando",
            ASSINADO: "Assinado",
            RECUSADO: "Recusado",
          }[statusParticipante];

          registros.push({
            id: participante.id,
            participanteId: participante.id,
            processoId: processo.id,
            entidadeId: processo.id,
            processoTipo: "assinaturafinal",

            categoriaInteracao: "ASSINATURA",
            tipo: "ASSINATURA",

            chave: `ASSINATURA-PARTICIPANTE-${processo.id}-${participante.id}`,

            __assinaturaCentral: true,
            __assinaturaParticipante: true,

            __assinaturaStatus: statusParticipante,
            __assinaturaStatusNome: statusNome,

            __dashboardProcessoOrigem: "ASSINATURAS",
            __dashboardProcessoTitulo: "ASSINATURA FINAL",

            __dashboardSituacao: statusNome.toUpperCase(),

            __dashboardChave: `ASSINATURAS-${processo.id}-${participante.id}`,

            codigo: processo.titulo || `Assinatura ${processo.id}`,

            processoTitulo: processo.titulo || `Assinatura ${processo.id}`,

            processoStatus: processo.statusFluxo || "",

            assinanteNome: participante.nome || "—",

            assinanteEmail: participante.email || "",

            assinantePapel: participante.papel || "—",

            ordem: participante.ordem ?? null,

            assinadoEm: participante.assinadoEm || null,

            /*
             * Campos reaproveitados pela grade principal.
             */
            solicitanteNome: participante.nome || "",

            naVezDe: participante.papel || "—",

            resumo: `${participante.nome || "Assinante"} — ${participante.papel || "Assinante"}`,

            atualizadoEm: participante.assinadoEm || processo.atualizadoEm || processo.dataEnvio || processo.criadoEm || null,

            /*
             * Ao clicar, direciona para Assinatura Final.
             */
            rota: "/assinatura-final",

            destino: {
              rota: "/assinatura-final",
              processoTipo: "assinaturafinal",
              entidadeId: processo.id,
            },
          });
        });
      });

      setAssinaturasParticipantes(registros);
    } catch (error) {
      console.error("Dashboard: erro ao carregar assinantes da esteira.", error);

      setAssinaturasParticipantes([]);
    }
  };

  useEffect(() => {
    buscarDadosDashboard();
    buscarAssinaturasParticipantes();

    const intervaloDashboard = setInterval(() => {
      buscarDadosDashboard();
      buscarAssinaturasParticipantes();
    }, 60000);

    const atualizarDashboardAoFocar = () => {
      buscarDadosDashboard();
      buscarAssinaturasParticipantes();
    };

    window.addEventListener("focus", atualizarDashboardAoFocar);

    return () => {
      clearInterval(intervaloDashboard);

      window.removeEventListener("focus", atualizarDashboardAoFocar);
    };
  }, []);

  /*
   * =====================================================
   * BUSCAR PENDÊNCIAS
   * =====================================================
   */

  const buscarPendencias = async () => {
    if (usandoDadosExternos) {
      return;
    }

    const token = getToken();

    if (!token) {
      setPendenciasInternas([]);
      setErroCarregamento("Não foi possível identificar a sessão do usuário.");
      return;
    }

    try {
      setLoadingInterno(true);
      setErroCarregamento("");

      const response = await fetch("/api/pendencias-aprovacao", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }

      const data = await response.json();

      const listaPendencias = Array.isArray(data?.pendencias) ? data.pendencias : [];

      const listaAcoes = Array.isArray(data?.acoesRealizadas) ? data.acoesRealizadas : [];

      setPendenciasInternas(listaPendencias);
      setAcoesRealizadasInternas(listaAcoes);

      setErroCarregamento("");
    } catch (err) {
      console.error("Erro ao buscar pendências da Central de Interação:", err);

      setPendenciasInternas([]);

      setErroCarregamento("Não foi possível carregar a Central de Interações.");
    } finally {
      setLoadingInterno(false);
    }
  };

  const atualizarCentral = async () => {
    if (usandoDadosExternos) {
      if (typeof onAtualizar === "function") {
        await onAtualizar();
      }

      return;
    }

    await buscarPendencias();
  };

  /*
   * =====================================================
   * ATUALIZAÇÃO AUTOMÁTICA
   * =====================================================
   */

  useEffect(() => {
    if (usandoDadosExternos) {
      return undefined;
    }

    buscarPendencias();

    const intervalo = setInterval(() => {
      buscarPendencias();
    }, 60000);

    const atualizarAoFocar = () => {
      buscarPendencias();
    };

    window.addEventListener("focus", atualizarAoFocar);

    return () => {
      clearInterval(intervalo);

      window.removeEventListener("focus", atualizarAoFocar);
    };
  }, [usandoDadosExternos]);

  /*
   * =====================================================
   * PERSISTÊNCIA DA CONFIGURAÇÃO DA GRID
   * =====================================================
   */

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    try {
      window.localStorage.setItem(GRID_STORAGE_ID, JSON.stringify(configuracaoGrid));
    } catch (err) {
      console.error("Central de Interação: erro ao salvar configuração da grid.", err);
    }
  }, [configuracaoGrid]);

  useEffect(() => {
    if (!filtroColunaAberto) {
      return undefined;
    }

    const fecharFiltroColuna = (event) => {
      const dentroDoFiltro = event.target.closest('[data-central-column-filter="true"]');

      if (!dentroDoFiltro) {
        setFiltroColunaAberto("");
      }
    };

    document.addEventListener("mousedown", fecharFiltroColuna);

    return () => {
      document.removeEventListener("mousedown", fecharFiltroColuna);
    };
  }, [filtroColunaAberto]);

  useEffect(() => {
    if (typeof onQuantidadeChange === "function") {
      onQuantidadeChange(pendencias.length);
    }
  }, [pendencias.length, onQuantidadeChange]);

  /*
   * =====================================================
   * NORMALIZAÇÃO
   * =====================================================
   */

  const normalizar = (valor) =>
    String(valor || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  /*
   * =====================================================
   * ESTEIRAS
   * =====================================================
   */

  const dashboardEsteiras = useMemo(() => {
    const criarContador = () => ({
      EM_DIGITACAO: 0,
      EM_APROVACAO: 0,
      COM_PENDENCIA: 0,
      APROVADA: 0,
      ASSINATURA_RASCUNHO: 0,
      EM_ASSINATURA: 0,
      ASSINADA: 0,
    });

    const proposta = criarContador();
    const ficha = criarContador();
    const analise = criarContador();
    const contrato = criarContador();

    /*
     * Esteira exclusiva de ASSINATURAS.
     *
     * A contagem é por PARTICIPANTE, nunca por processo.
     */
    const assinaturas = {
      PENDENTE: 0,
      AGUARDANDO: 0,
      ASSINADO: 0,
      RECUSADO: 0,
    };

    assinaturasParticipantes.forEach((registro) => {
      const status = registro?.__assinaturaStatus;

      if (Object.prototype.hasOwnProperty.call(assinaturas, status)) {
        assinaturas[status] += 1;
      }
    });

    const gerais = {
      REPROVADA: 0,
      INUTILIZADA: 0,
      ASSINATURA_CANCELADA: 0,
      CONCLUIDA: 0,
    };

    const statusAssinaturaEtapa = (status) => {
      const valor = String(status || "")
        .trim()
        .toUpperCase();

      if (valor === "RASCUNHO" || valor === "PRONTO_PARA_ENVIO") {
        return "ASSINATURA_RASCUNHO";
      }

      if (["ENVIADO", "AGUARDANDO_ASSINATURAS", "PARCIALMENTE_ASSINADO", "EM_ASSINATURA_FISICA"].includes(valor)) {
        return "EM_ASSINATURA";
      }

      if (valor === "ASSINADO" || valor === "ARQUIVADO") {
        return "ASSINADA";
      }

      return "";
    };

    propostasDashboard.forEach((item) => {
      /*
       * PROPOSTA COMERCIAL
       */

      const assinaturaProposta = statusAssinaturaEtapa(item.statusAssinatura);

      if (item.statusAssinatura === "CANCELADO") {
        gerais.ASSINATURA_CANCELADA += 1;
      } else if (assinaturaProposta) {
        proposta[assinaturaProposta] += 1;
      } else {
        switch (item.statusGeral) {
          case "EmDigitacao":
            proposta.EM_DIGITACAO += 1;
            break;

          case "EmAprovacao":
            proposta.EM_APROVACAO += 1;
            break;

          case "ComPendencias":
            proposta.COM_PENDENCIA += 1;
            break;

          case "Aprovada":
            proposta.APROVADA += 1;
            break;

          case "Reprovada":
            gerais.REPROVADA += 1;
            break;

          case "Inutilizada":
            gerais.INUTILIZADA += 1;
            break;

          default:
            break;
        }
      }

      /*
       * FICHA DE CADASTRO
       */

      switch (item.statusFichas) {
        case "EmPreenchimento":
          ficha.EM_DIGITACAO += 1;
          break;

        case "EmAprovacao":
          ficha.EM_APROVACAO += 1;
          break;

        case "Aprovada":
          ficha.APROVADA += 1;
          break;

        case "Reprovada":
          gerais.REPROVADA += 1;
          break;

        case "Inutilizada":
          gerais.INUTILIZADA += 1;
          break;

        default:
          break;
      }

      /*
       * ANÁLISE DE CRÉDITO
       */

      switch (item.statusAnaliseCredito) {
        case "AguardandoUpload":
          analise.EM_DIGITACAO += 1;
          break;

        case "EmAprovacao":
          analise.EM_APROVACAO += 1;
          break;

        case "Aprovada":
          analise.APROVADA += 1;
          break;

        case "Reprovada":
          gerais.REPROVADA += 1;
          break;

        default:
          break;
      }

      /*
       * CONTRATO
       */

      const assinaturaContrato = statusAssinaturaEtapa(item.statusAssinaturaContrato);

      if (item.statusAssinaturaContrato === "CANCELADO") {
        gerais.ASSINATURA_CANCELADA += 1;
      } else if (assinaturaContrato) {
        contrato[assinaturaContrato] += 1;

        if (["ASSINADO", "ARQUIVADO"].includes(String(item.statusAssinaturaContrato || "").toUpperCase())) {
          gerais.CONCLUIDA += 1;
        }
      } else {
        switch (item.statusMinutaContrato) {
          case "EmElaboracao":
            contrato.EM_DIGITACAO += 1;
            break;

          case "EmAprovacao":
            contrato.EM_APROVACAO += 1;
            break;

          case "Aprovado":
            contrato.APROVADA += 1;
            break;

          case "Reprovado":
            gerais.REPROVADA += 1;
            break;

          case "Inutilizado":
          case "Invalidado":
            gerais.INUTILIZADA += 1;
            break;

          default:
            break;
        }
      }
    });

    /*
     * TEMPLATE DE CONTRATO
     * Reprovado / Inutilizado entram em STATUS GERAIS.
     */
    const template = criarContador();

    templatesDashboard.forEach((item) => {
      switch (item.statusAprovacao) {
        case "EmElaboracao":
          template.EM_DIGITACAO += 1;
          break;

        case "EmAprovacao":
          template.EM_APROVACAO += 1;
          break;

        case "Aprovado":
          template.APROVADA += 1;
          break;

        case "Reprovado":
          gerais.REPROVADA += 1;
          break;

        case "Inutilizado":
          gerais.INUTILIZADA += 1;
          break;

        default:
          break;
      }
    });

    const aplicarValores = (chave, valores) => {
      const configuracao = DASHBOARD_ESTEIRAS.find((item) => item.chave === chave);

      return {
        ...configuracao,

        etapas: configuracao.etapas.map((etapa) => ({
          ...etapa,
          valor: valores[etapa.chave] || 0,
        })),
      };
    };

    return [
      aplicarValores("PROPOSTA", proposta),
      aplicarValores("FICHA", ficha),
      aplicarValores("ANALISE", analise),
      aplicarValores("CONTRATO", contrato),
      aplicarValores("TEMPLATE", template),
      aplicarValores("ASSINATURAS", assinaturas),
      aplicarValores("GERAL", gerais),
    ];
  }, [propostasDashboard, assinaturasParticipantes, templatesDashboard]);

  /*
   * =====================================================
   * DETALHAMENTO DO DASHBOARD
   * =====================================================
   */

  const registrosDashboardFiltrados = useMemo(() => {
    if (!filtroDashboardSelecionado) {
      return [];
    }

    const { processo, status } = filtroDashboardSelecionado;

    const classificarAssinatura = (statusAssinatura) => {
      const valor = String(statusAssinatura || "")
        .trim()
        .toUpperCase();

      if (valor === "RASCUNHO" || valor === "PRONTO_PARA_ENVIO") {
        return "ASSINATURA_RASCUNHO";
      }

      if (["ENVIADO", "AGUARDANDO_ASSINATURAS", "PARCIALMENTE_ASSINADO", "EM_ASSINATURA_FISICA"].includes(valor)) {
        return "EM_ASSINATURA";
      }

      if (valor === "ASSINADO" || valor === "ARQUIVADO") {
        return "ASSINADA";
      }

      return "";
    };

    if (processo === "GERAL") {
      const ocorrencias = [];

      const adicionarOcorrencia = (item, processoOrigem, processoTitulo, situacao) => {
        ocorrencias.push({
          ...item,

          __dashboardProcessoOrigem: processoOrigem,

          __dashboardProcessoTitulo: processoTitulo,

          __dashboardSituacao: situacao,

          __dashboardChave: `${status}-${processoOrigem}-${item.id}`,
        });
      };

      propostasDashboard.forEach((item) => {
        const assinaturaProposta = classificarAssinatura(item.statusAssinatura);

        const assinaturaContrato = classificarAssinatura(item.statusAssinaturaContrato);

        if (status === "REPROVADA") {
          if (item.statusAssinatura !== "CANCELADO" && !assinaturaProposta && item.statusGeral === "Reprovada") {
            adicionarOcorrencia(item, "PROPOSTA", "PROPOSTA COMERCIAL", "REPROVADA");
          }

          if (item.statusFichas === "Reprovada") {
            adicionarOcorrencia(item, "FICHA", "FICHA DE CADASTRO", "REPROVADA");
          }

          if (item.statusAnaliseCredito === "Reprovada") {
            adicionarOcorrencia(item, "ANALISE", "ANÁLISE DE CRÉDITO", "REPROVADA");
          }

          if (item.statusAssinaturaContrato !== "CANCELADO" && !assinaturaContrato && item.statusMinutaContrato === "Reprovado") {
            adicionarOcorrencia(item, "CONTRATO", "CONTRATO", "REPROVADA");
          }

          return;
        }

        if (status === "INUTILIZADA") {
          if (item.statusAssinatura !== "CANCELADO" && !assinaturaProposta && item.statusGeral === "Inutilizada") {
            adicionarOcorrencia(item, "PROPOSTA", "PROPOSTA COMERCIAL", "INUTILIZADA");
          }

          if (item.statusFichas === "Inutilizada") {
            adicionarOcorrencia(item, "FICHA", "FICHA DE CADASTRO", "INUTILIZADA");
          }

          if (item.statusAssinaturaContrato !== "CANCELADO" && !assinaturaContrato && ["Inutilizado", "Invalidado"].includes(item.statusMinutaContrato)) {
            adicionarOcorrencia(item, "CONTRATO", "CONTRATO", "INUTILIZADA");
          }

          return;
        }

        if (status === "ASSINATURA_CANCELADA") {
          if (item.statusAssinatura === "CANCELADO") {
            adicionarOcorrencia(item, "PROPOSTA", "PROPOSTA COMERCIAL", "ASSINATURA CANCELADA");
          }

          if (item.statusAssinaturaContrato === "CANCELADO") {
            adicionarOcorrencia(item, "CONTRATO", "CONTRATO", "ASSINATURA CANCELADA");
          }

          return;
        }

        if (status === "CONCLUIDA") {
          const statusContrato = String(item.statusAssinaturaContrato || "").toUpperCase();

          if (["ASSINADO", "ARQUIVADO"].includes(statusContrato)) {
            adicionarOcorrencia(item, "CONTRATO", "CONTRATO", "CONCLUÍDA");
          }
        }
      });

      /*
       * Templates de contrato reprovados / inutilizados.
       */
      templatesDashboard.forEach((templateItem) => {
        const situacaoTemplate =
          status === "REPROVADA" && templateItem.statusAprovacao === "Reprovado"
            ? "REPROVADO"
            : status === "INUTILIZADA" && templateItem.statusAprovacao === "Inutilizado"
              ? "INUTILIZADO"
              : "";

        if (situacaoTemplate) {
          adicionarOcorrencia({ ...templateItem, codigo: templateItem.nome }, "TEMPLATE", "TEMPLATE DE CONTRATO", situacaoTemplate);
        }
      });

      return ocorrencias;
    }

    /*
     * =====================================================
     * TEMPLATE DE CONTRATO
     * =====================================================
     */

    if (processo === "TEMPLATE") {
      const mapaTemplate = {
        EmElaboracao: "EM_DIGITACAO",
        EmAprovacao: "EM_APROVACAO",
        Aprovado: "APROVADA",
      };

      return templatesDashboard
        .filter((templateItem) => mapaTemplate[templateItem.statusAprovacao] === status)
        .map((templateItem) => ({
          ...templateItem,
          codigo: templateItem.nome,
          __dashboardProcessoOrigem: "TEMPLATE",
          __dashboardChave: `TEMPLATE-${templateItem.id}`,
        }));
    }

    /*
     * =====================================================
     * ASSINATURAS
     * =====================================================
     */

    if (processo === "ASSINATURAS") {
      return assinaturasParticipantes.filter((registro) => registro.__assinaturaStatus === status);
    }

    return propostasDashboard.filter((item) => {
      if (processo === "PROPOSTA") {
        if (item.statusAssinatura === "CANCELADO") {
          return false;
        }

        const assinatura = classificarAssinatura(item.statusAssinatura);

        if (assinatura) {
          return assinatura === status;
        }

        const mapa = {
          EmDigitacao: "EM_DIGITACAO",
          EmAprovacao: "EM_APROVACAO",
          ComPendencias: "COM_PENDENCIA",
          Aprovada: "APROVADA",
        };

        return mapa[item.statusGeral] === status;
      }

      if (processo === "FICHA") {
        const mapa = {
          EmPreenchimento: "EM_DIGITACAO",
          EmAprovacao: "EM_APROVACAO",
          Aprovada: "APROVADA",
        };

        return mapa[item.statusFichas] === status;
      }

      if (processo === "ANALISE") {
        const mapa = {
          AguardandoUpload: "EM_DIGITACAO",
          EmAprovacao: "EM_APROVACAO",
          Aprovada: "APROVADA",
        };

        return mapa[item.statusAnaliseCredito] === status;
      }

      if (processo === "CONTRATO") {
        if (item.statusAssinaturaContrato === "CANCELADO") {
          return false;
        }

        const assinatura = classificarAssinatura(item.statusAssinaturaContrato);

        if (assinatura) {
          return assinatura === status;
        }

        const mapa = {
          EmElaboracao: "EM_DIGITACAO",
          EmAprovacao: "EM_APROVACAO",
          Aprovado: "APROVADA",
        };

        return mapa[item.statusMinutaContrato] === status;
      }

      return false;
    });
  }, [propostasDashboard, assinaturasParticipantes, templatesDashboard, filtroDashboardSelecionado]);

  const abrirEtapaDashboard = (processo, status) => {
    const esteira = DASHBOARD_ESTEIRAS.find((item) => item.chave === processo);

    const etapa = esteira?.etapas?.find((item) => item.chave === status);

    setFiltroDashboardSelecionado({
      processo,
      status,
      processoTitulo: esteira?.titulo || processo,
      statusTitulo: etapa?.titulo || status,
    });
  };

  /*
   * NA VEZ DE
   * Quem precisa agir no processo, conforme a etapa clicada na esteira.
   */
  const naVezDeDashboardItem = (item) => {
    if (!item || !filtroDashboardSelecionado) {
      return null;
    }

    const { processo, status } = filtroDashboardSelecionado;

    const origem = item.__dashboardProcessoOrigem || processo;

    const id = item.id;

    const buscar = (...chaves) => {
      for (const chave of chaves) {
        if (chave && naVezDeDashboard[chave]) {
          return naVezDeDashboard[chave];
        }
      }

      return null;
    };

    if (processo === "ASSINATURAS") {
      if (item.__assinaturaStatus === "PENDENTE") {
        return { nomes: [item.assinanteNome].filter(Boolean), acao: "Assinatura" };
      }

      if (item.__assinaturaStatus === "AGUARDANDO") {
        return buscar(`ASSINATURA_PROCESSO-${item.processoId}`);
      }

      return null;
    }

    if (processo === "GERAL") {
      if (status !== "REPROVADA") {
        return null;
      }

      if (origem === "TEMPLATE") {
        return buscar(`CRIADOR_TEMPLATE-${id}`);
      }

      if (origem === "CONTRATO") {
        return buscar(`CRIADOR_CONTRATO-${id}`);
      }

      return buscar(`CRIADOR_PROPOSTA-${id}`);
    }

    if (processo === "PROPOSTA") {
      if (status === "EM_APROVACAO" || status === "COM_PENDENCIA") {
        return buscar(`PROPOSTA-${id}`, `CRIADOR_PROPOSTA-${id}`);
      }

      if (status === "ASSINATURA_RASCUNHO" || status === "EM_ASSINATURA") {
        return buscar(`ASSINATURA_PROPOSTA-${id}`);
      }

      if (status === "EM_DIGITACAO" || status === "APROVADA") {
        return buscar(`CRIADOR_PROPOSTA-${id}`);
      }

      return null;
    }

    if (processo === "FICHA" || processo === "ANALISE") {
      if (status === "EM_APROVACAO") {
        return buscar(`${processo}-${id}`);
      }

      if (status === "EM_DIGITACAO") {
        return buscar(`CRIADOR_PROPOSTA-${id}`);
      }

      return null;
    }

    if (processo === "CONTRATO") {
      if (status === "EM_APROVACAO") {
        return buscar(`CONTRATO-${id}`);
      }

      if (status === "ASSINATURA_RASCUNHO" || status === "EM_ASSINATURA") {
        return buscar(`ASSINATURA_CONTRATO-${id}`);
      }

      if (status === "EM_DIGITACAO" || status === "APROVADA") {
        return buscar(`CRIADOR_CONTRATO-${id}`);
      }

      return null;
    }

    if (processo === "TEMPLATE") {
      if (status === "EM_APROVACAO") {
        return buscar(`TEMPLATE-${id}`);
      }

      if (status === "EM_DIGITACAO") {
        return buscar(`CRIADOR_TEMPLATE-${id}`);
      }

      return null;
    }

    return null;
  };

  const celulaNaVezDe = (item) => {
    const naVez = naVezDeDashboardItem(item);

    if (!naVez || !naVez.nomes?.length) {
      return <span className="text-[color:var(--ig-t-6b7280)]">—</span>;
    }

    return (
      <div className="leading-tight">
        <div className="font-semibold text-[color:var(--ig-t-e5e7eb)]">{naVez.nomes.join(", ")}</div>

        {naVez.acao && <div className="text-[11px] text-[color:var(--ig-t-9ca3af)] mt-0.5">{naVez.acao}</div>}
      </div>
    );
  };

  const nomeLocatariaDashboard = (item) => {
    const pessoas = Array.isArray(item?.fichaPessoas) ? item.fichaPessoas : [];

    const locataria = pessoas.find((pessoa) => normalizar(pessoa?.campoProposta).includes("locataria"));

    return locataria?.razaoSocial || locataria?.pfNome || "—";
  };

  const imovelDashboard = (item) => {
    return item?.imovel?.apelido || item?.imovel?.codigoMatricula || item?.enderecoImovel || "—";
  };

  const abrirRegistroDashboard = async (item) => {
    if (!item || !filtroDashboardSelecionado) {
      return;
    }

    const processo = item?.__dashboardProcessoOrigem || filtroDashboardSelecionado.processo;

    /*
     * Assinaturas possuem processo próprio.
     */
    if (processo === "ASSINATURAS") {
      if (modoOverlay && typeof onFechar === "function") {
        onFechar();
      }

      const processoId = Number(item?.processoId ?? item?.entidadeId ?? item?.destino?.entidadeId);

      const esperarElemento = (localizar, limiteMs = 5000) =>
        new Promise((resolve, reject) => {
          const inicio = Date.now();

          const verificar = () => {
            try {
              const resultado = localizar();

              if (resultado) {
                resolve(resultado);
                return;
              }
            } catch (error) {
              console.error("Dashboard: erro ao procurar assinatura.", error);
            }

            if (Date.now() - inicio >= limiteMs) {
              reject(new Error("Assinatura não ficou disponível."));
              return;
            }

            setTimeout(verificar, 150);
          };

          verificar();
        });

      navigate("/assinatura-final");

      if (Number.isInteger(processoId) && processoId > 0) {
        try {
          const linha = await esperarElemento(() => {
            if (window.location.pathname !== "/assinatura-final") {
              return null;
            }

            const tituloProcurado = normalizar(item?.processoTitulo || item?.codigo || "");

            return Array.from(document.querySelectorAll("tbody tr")).find((tr) => {
              const textoLinha = normalizar(tr.textContent);

              return (tituloProcurado && textoLinha.includes(tituloProcurado)) || textoLinha.includes(String(processoId));
            });
          }, 5000);

          const primeiraCelula = linha.querySelector("td");

          const botaoVisualizar = primeiraCelula?.querySelector("button");

          if (botaoVisualizar) {
            botaoVisualizar.scrollIntoView({
              behavior: "auto",
              block: "center",
            });

            botaoVisualizar.dispatchEvent(
              new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              }),
            );
          }
        } catch (error) {
          console.error("Dashboard: não foi possível abrir automaticamente a Assinatura Final.", {
            processoId,
            item,
            erro: error?.message || error,
          });
        }
      }

      return;
    }

    /*
     * Template de contrato: mesmo fluxo de abertura da Central
     * (tela de Templates filtrada pelo nome).
     */
    if (processo === "TEMPLATE") {
      await abrirPendencia({
        ...item,
        codigo: item?.nome || item?.codigo || "",
        entidadeId: Number(item.id),
        processoTipo: "templatecontrato",
        tipo: filtroDashboardSelecionado.status === "EM_APROVACAO" ? "APROVAR" : "",
        destino: {
          processoTipo: "templatecontrato",
          entidadeId: Number(item.id),
        },
      });

      return;
    }

    const propostaId = Number(item.id);

    if (!Number.isInteger(propostaId) || propostaId <= 0) {
      console.error("Dashboard: proposta inválida.", item);

      return;
    }

    /*
     * Reaproveitamos o MESMO fluxo da Central de Interações.
     *
     * Assim não teremos uma lógica para o Dashboard
     * e outra lógica diferente para a Central.
     */
    const mapaProcessos = {
      PROPOSTA: "proposta",
      FICHA: "fichas",
      ANALISE: "analisecredito",
      CONTRATO: "contrato",
    };

    const processoTipo = mapaProcessos[processo];

    if (!processoTipo) {
      console.error("Dashboard: processo não tratado.", {
        processo,
        item,
      });

      return;
    }

    const status = filtroDashboardSelecionado.status;

    /*
     * Quando estivermos em aprovação, o fluxo da Central
     * também tentará posicionar o usuário na ação APROVAR.
     *
     * Nos demais estados apenas abrimos o registro.
     */
    const tipo = status === "EM_APROVACAO" ? "APROVAR" : "";

    const pendenciaDashboard = {
      ...item,

      codigo: item?.codigo || `PC${propostaId}`,

      entidadeId: propostaId,

      processoTipo,

      tipo,

      destino: {
        processoTipo,
        entidadeId: propostaId,
      },
    };

    await abrirPendencia(pendenciaDashboard);
  };

  /*
   * =====================================================
   * PROCESSO
   * =====================================================
   */

  const nomeProcesso = (pendencia) => {
    const processo = String(pendencia?.destino?.processoTipo || pendencia?.processoTipo || "")
      .trim()
      .toLowerCase();

    if (processo === "proposta") {
      return "Proposta Comercial";
    }

    if (processo === "fichas") {
      return "Ficha Cadastro";
    }

    if (processo === "analisecredito") {
      return "Análise de Crédito";
    }

    if (processo === "contrato") {
      return "Contrato";
    }
    if (processo === "templatecontrato") {
      return "Template de Contrato";
    }

    if (processo === "alteracaocontratual") {
      return "Alteração Contratual";
    }

    if (processo === "assinatura" || processo === "assinaturafinal") {
      return "Assinatura Final";
    }

    return pendencia?.modulo || pendencia?.processoTipo || "OUTRAS INTERAÇÕES";
  };

  /*
   * =====================================================
   * CATEGORIA / TIPO DA INTERAÇÃO
   * =====================================================
   */

  const situacaoInteracao = (pendencia) => {
    const categoriaBackend = normalizar(pendencia?.categoriaInteracao || pendencia?.categoria || pendencia?.tipoCategoria || "").toUpperCase();

    const mapaCategorias = {
      APROVACAO: "APROVAÇÃO",
      APROVAR: "APROVAÇÃO",

      QUESTIONAMENTO: "QUESTIONAMENTO",
      RESPONDER: "QUESTIONAMENTO",
      PERGUNTA: "QUESTIONAMENTO",

      REVISAO: "REVISÃO",
      REVISAR: "REVISÃO",

      REPROVACAO: "REPROVAÇÃO",
      REPROVAR: "REPROVAÇÃO",
      DEVOLVIDO: "REPROVAÇÃO",
      DEVOLVIDA: "REPROVAÇÃO",

      ASSINATURA: "ASSINATURA",
      ASSINAR: "ASSINATURA",

      // Alterações contratuais na etapa sob responsabilidade do usuário.
      ANDAMENTO: "ANDAMENTO",
    };

    if (mapaCategorias[categoriaBackend]) {
      return mapaCategorias[categoriaBackend];
    }

    const tipo = normalizar(pendencia?.tipo || "").toUpperCase();

    const acaoNecessaria = normalizar(pendencia?.acaoNecessaria || pendencia?.acao || pendencia?.destino?.acao || "");

    const textoClassificacao = normalizar(
      [
        pendencia?.situacao,
        pendencia?.status,
        pendencia?.statusDescricao,
        pendencia?.mensagem,
        pendencia?.resumo,
        pendencia?.questionamento,
        pendencia?.descricao,
      ].join(" "),
    );

    if (textoClassificacao.includes("reprov") || textoClassificacao.includes("devolvid")) {
      return "REPROVAÇÃO";
    }

    if (tipo === "ASSINAR" || tipo === "ASSINATURA" || textoClassificacao.includes("aguardando assinatura")) {
      return "ASSINATURA";
    }

    if (
      (tipo === "RESPONDER" || tipo === "QUESTIONAMENTO" || tipo === "PERGUNTA") &&
      (acaoNecessaria.includes("visualizar") || acaoNecessaria.includes("ciencia") || textoClassificacao.includes("aguardando ciencia"))
    ) {
      return "REVISÃO";
    }

    if (tipo === "REVISAR" || tipo === "REVISAO") {
      return "REVISÃO";
    }

    if (tipo === "RESPONDER" || tipo === "QUESTIONAMENTO" || tipo === "PERGUNTA") {
      return "QUESTIONAMENTO";
    }

    if (tipo === "REPROVAR" || tipo === "REPROVACAO") {
      return "REPROVAÇÃO";
    }

    if (tipo === "APROVAR" || tipo === "APROVACAO") {
      return "APROVAÇÃO";
    }

    return "INTERAÇÃO";
  };

  /*
   * =====================================================
   * AÇÃO REALIZADA
   * =====================================================
   */

  const acaoRealizadaRegistro = (registro) => {
    const acao = normalizar(
      registro?.acaoRealizada || registro?.acaoExecutada || registro?.resultadoAcao || registro?.tipoAcao || registro?.acao || registro?.tipo || "",
    ).toUpperCase();

    const mapa = {
      APROVAR: "APROVADO",
      APROVADO: "APROVADO",
      APROVACAO: "APROVADO",

      REPROVAR: "REPROVADO",
      REPROVADO: "REPROVADO",
      REPROVACAO: "REPROVADO",

      QUESTIONAR: "QUESTIONADO",
      QUESTIONADO: "QUESTIONADO",
      QUESTIONAMENTO: "QUESTIONADO",

      RESPONDER: "RESPONDIDO",
      RESPONDIDO: "RESPONDIDO",
      RESPOSTA: "RESPONDIDO",

      REVISAR: "REVISADO",
      REVISADO: "REVISADO",
      REVISAO: "REVISADO",

      ASSINAR: "ASSINADO",
      ASSINADO: "ASSINADO",
      ASSINATURA: "ASSINADO",
    };

    return mapa[acao] || "AÇÃO REALIZADA";
  };

  /*
   * =====================================================
   * CONTADORES
   * =====================================================
   */

  const contadoresCategoria = useMemo(() => {
    return pendencias.reduce((contadores, pendencia) => {
      const categoria = situacaoInteracao(pendencia);

      contadores[categoria] = (contadores[categoria] || 0) + 1;

      return contadores;
    }, {});
  }, [pendencias]);

  const estiloCategoriaAtiva = (categoria) => {
    switch (categoria) {
      case "TODOS":
        return {
          botao: "bg-[#5a3319] border-[#8a4b20] text-orange-300",
          contador: "bg-[#c2410c] text-white",
        };

      case "APROVAÇÃO":
        return {
          botao: "bg-[#123b5a] border-[#1d6594] text-[#60b9f4]",
          contador: "bg-[#14618d] text-white",
        };

      case "QUESTIONAMENTO":
        return {
          botao: "bg-[#4a3a0b] border-[#806313] text-[#facc15]",
          contador: "bg-[#9a7208] text-white",
        };

      case "REVISÃO":
        return {
          botao: "bg-[#39205c] border-[#67409a] text-[#c084fc]",
          contador: "bg-[#6b35a1] text-white",
        };

      case "REPROVAÇÃO":
        return {
          botao: "bg-[#511e24] border-[#8f303a] text-[#f87171]",
          contador: "bg-[#a52e3a] text-white",
        };

      case "ASSINATURA":
        return {
          botao: "bg-[#432153] border-[#713b88] text-[#d8b4fe]",
          contador: "bg-[#75358e] text-white",
        };

      case "ANDAMENTO":
        return {
          botao: "bg-[#173d2b] border-[#227447] text-[#4ade80]",
          contador: "bg-[#227447] text-white",
        };

      case "APROVADO":
        return {
          botao: "bg-[#173d2b] border-[#227447] text-[#4ade80]",
          contador: "bg-[#227447] text-white",
        };

      case "REPROVADO":
        return {
          botao: "bg-[#511e24] border-[#8f303a] text-[#f87171]",
          contador: "bg-[#a52e3a] text-white",
        };

      case "QUESTIONADO":
        return {
          botao: "bg-[#39205c] border-[#67409a] text-[#c084fc]",
          contador: "bg-[#6b35a1] text-white",
        };

      case "RESPONDIDO":
        return {
          botao: "bg-[#123b5a] border-[#1d6594] text-[#60b9f4]",
          contador: "bg-[#14618d] text-white",
        };

      case "REVISADO":
        return {
          botao: "bg-[#5a3213] border-[#8a4c1d] text-[#fb923c]",
          contador: "bg-[#9a531d] text-white",
        };

      case "PENDENTE":
        return {
          botao: "bg-[#5a4213] border-[#8a681d] text-[#fbbf24]",
          contador: "bg-[#a56f11] text-white",
        };

      case "AGUARDANDO":
        return {
          botao: "bg-[#123b5a] border-[#1d6594] text-[#60b9f4]",
          contador: "bg-[#14618d] text-white",
        };

      case "ASSINADO":
        return {
          botao: "bg-[#173d2b] border-[#227447] text-[#4ade80]",
          contador: "bg-[#227447] text-white",
        };

      case "RECUSADO":
        return {
          botao: "bg-[#511e24] border-[#8f303a] text-[#f87171]",
          contador: "bg-[#a52e3a] text-white",
        };

      default:
        return {
          botao: "bg-[color:var(--ig-f-171d2c)] border-[color:var(--ig-b-30394c)] text-[color:var(--ig-t-e5e7eb)]",
          contador: "bg-[color:var(--ig-f-202738)] text-[color:var(--ig-t-d1d5db)]",
        };
    }
  };

  const contadoresMinhasAcoes = useMemo(() => {
    return acoesRealizadasInternas.reduce((contadores, registro) => {
      const acao = acaoRealizadaRegistro(registro);

      contadores[acao] = (contadores[acao] || 0) + 1;

      return contadores;
    }, {});
  }, [acoesRealizadasInternas]);

  /*
   * =====================================================
   * CONTADORES - ASSINATURAS
   * =====================================================
   */

  const contadoresAssinaturas = useMemo(() => {
    return registrosAssinaturasCentral.reduce((contadores, registro) => {
      const status = registro.__assinaturaStatus;

      if (status) {
        contadores[status] = (contadores[status] || 0) + 1;
      }

      return contadores;
    }, {});
  }, [registrosAssinaturasCentral]);

  const categoriasAssinaturas = [
    {
      chave: "TODOS",
      nome: "Todos",
      quantidade: registrosAssinaturasCentral.length,
      Icone: FaClipboardList,
    },
    {
      chave: "PENDENTE",
      nome: "Pendentes",
      quantidade: contadoresAssinaturas.PENDENTE || 0,
      Icone: FaHourglassHalf,
    },
    {
      chave: "AGUARDANDO",
      nome: "Aguardando",
      quantidade: contadoresAssinaturas.AGUARDANDO || 0,
      Icone: FaHourglassHalf,
    },
    {
      chave: "ASSINADO",
      nome: "Assinados",
      quantidade: contadoresAssinaturas.ASSINADO || 0,
      Icone: FaHandshake,
    },
    {
      chave: "RECUSADO",
      nome: "Recusados",
      quantidade: contadoresAssinaturas.RECUSADO || 0,
      Icone: FaBan,
    },
  ];

  const categorias = [
    {
      chave: "TODOS",
      nome: "Todos",
      quantidade: pendencias.length,
      Icone: FaClipboardList,
    },
    {
      chave: "APROVAÇÃO",
      nome: "Aprovações",
      quantidade: contadoresCategoria["APROVAÇÃO"] || 0,
      Icone: FaCheckCircle,
    },
    {
      chave: "QUESTIONAMENTO",
      nome: "Questionamentos",
      quantidade: contadoresCategoria["QUESTIONAMENTO"] || 0,
      Icone: FaComments,
    },
    {
      chave: "REVISÃO",
      nome: "Revisões",
      quantidade: contadoresCategoria["REVISÃO"] || 0,
      Icone: FaUndoAlt,
    },
    {
      chave: "REPROVAÇÃO",
      nome: "Reprovações",
      quantidade: contadoresCategoria["REPROVAÇÃO"] || 0,
      Icone: FaBan,
    },
    {
      chave: "ASSINATURA",
      nome: "Assinaturas",
      quantidade: contadoresCategoria["ASSINATURA"] || 0,
      Icone: FaPen,
    },
    {
      chave: "ANDAMENTO",
      nome: "Andamentos",
      quantidade: contadoresCategoria["ANDAMENTO"] || 0,
      Icone: FaClipboardList,
    },
  ];

  const categoriasHistoricos = [
    {
      chave: "TODOS",
      nome: "Todos",
      quantidade: acoesRealizadasInternas.length,
      Icone: FaClipboardList,
    },
    {
      chave: "APROVADO",
      nome: "Aprovados",
      quantidade: contadoresMinhasAcoes.APROVADO || 0,
      Icone: FaCheckCircle,
    },
    {
      chave: "REPROVADO",
      nome: "Reprovados",
      quantidade: contadoresMinhasAcoes.REPROVADO || 0,
      Icone: FaBan,
    },
    {
      chave: "QUESTIONADO",
      nome: "Questionados",
      quantidade: contadoresMinhasAcoes.QUESTIONADO || 0,
      Icone: FaComments,
    },
    {
      chave: "RESPONDIDO",
      nome: "Respondidos",
      quantidade: contadoresMinhasAcoes.RESPONDIDO || 0,
      Icone: FaComments,
    },
    {
      chave: "REVISADO",
      nome: "Revisados",
      quantidade: contadoresMinhasAcoes.REVISADO || 0,
      Icone: FaUndoAlt,
    },
    {
      chave: "ASSINADO",
      nome: "Assinados",
      quantidade: contadoresMinhasAcoes.ASSINADO || 0,
      Icone: FaPen,
    },
  ];

  const categoriasVisaoAtual =
    visaoSelecionada === "HISTORICOS" ? categoriasHistoricos : visaoSelecionada === "ASSINATURAS" ? categoriasAssinaturas : categorias;

  /*
   * =====================================================
   * DATAS
   * =====================================================
   */

  const obterDataPendencia = (pendencia) => {
    return pendencia?.ocorridoEm || pendencia?.atualizadoEm || pendencia?.recebidoEm || pendencia?.disponivelEm || null;
  };

  const formatarDataHora = (valor) => {
    if (!valor) {
      return "—";
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
      return "—";
    }

    const dataFormatada = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(data);

    const horaFormatada = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(data);

    return `${dataFormatada} ${horaFormatada}`;
  };

  const formatarDataParaFiltro = (valor) => {
    if (!valor) {
      return "";
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
      return "";
    }

    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");

    return `${ano}-${mes}-${dia}`;
  };

  const formatarDataRelativa = (valor) => {
    if (!valor) {
      return "—";
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
      return "—";
    }

    const hoje = new Date();

    const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

    const dataSemHora = new Date(data.getFullYear(), data.getMonth(), data.getDate());

    const diferencaMs = hojeSemHora.getTime() - dataSemHora.getTime();

    const diferencaDias = Math.round(diferencaMs / (1000 * 60 * 60 * 24));

    if (diferencaDias === 0) {
      return "Hoje";
    }

    if (diferencaDias === 1) {
      return "Ontem";
    }

    if (diferencaDias > 1 && diferencaDias < 7) {
      return `${diferencaDias} dias`;
    }

    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(data);
  };

  /*
   * =====================================================
   * DESCRIÇÃO
   * =====================================================
   */

  const descricaoPendencia = (pendencia) => {
    if (pendencia?.resumo) {
      return pendencia.resumo;
    }

    if (pendencia?.mensagem) {
      return pendencia.mensagem;
    }

    if (pendencia?.questionamento) {
      return pendencia.questionamento;
    }

    if (pendencia?.descricao) {
      return pendencia.descricao;
    }

    return "Interação pendente.";
  };

  const nomeCompletoLocatario = (pendencia) => {
    const nome = String(pendencia?.locatario?.nome || pendencia?.locatarioNome || pendencia?.nomeLocatario || "").trim();

    return nome.replace(/\s+(?:\d{3}\.?\d{3}\.?\d{3}-?\d{2}|\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}|\d{11}|\d{14})\s*$/, "").trim();
  };

  const identificacaoRegistro = (pendencia) => {
    /*
     * Na visão de assinaturas esta coluna passa
     * a mostrar o e-mail do assinante.
     */
    if (pendencia?.__assinaturaParticipante) {
      return String(pendencia?.assinanteEmail || "").trim() || "—";
    }

    const apelidoImovel = String(pendencia?.imovel?.apelido || pendencia?.apelidoImovel || pendencia?.imovel?.nome || "").trim();

    const locatarioCompleto = nomeCompletoLocatario(pendencia);

    const locatarioExibicao = locatarioCompleto.slice(0, 10).trim();

    if (apelidoImovel && locatarioExibicao) {
      return `${apelidoImovel} / ${locatarioExibicao}`;
    }

    if (apelidoImovel) {
      return apelidoImovel;
    }

    if (locatarioExibicao) {
      return locatarioExibicao;
    }

    return "—";
  };

  /*
   * =====================================================
   * APROVADORES
   * =====================================================
   */

  const nomeAprovadorDashboard = (usuario) => {
    return String(usuario?.usuarioNome || usuario?.nome || usuario?.nomeCompleto || usuario?.email || "").trim() || "—";
  };

  const ultimoAcessoAprovador = (usuario) => {
    return usuario?.ultimoAcesso || null;
  };

  const formatarUltimoAcessoAprovador = (valor) => {
    if (!valor) {
      return "—";
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
      return "—";
    }

    const dataFormatada = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(data);

    const horaFormatada = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(data);

    return `${dataFormatada} - ${horaFormatada}`;
  };

  const acoesParadasAprovador = (usuario) => {
    return Array.isArray(usuario?.acoesParadas) ? usuario.acoesParadas : [];
  };

  const codigoPendencia = (pendencia) => {
    const codigo =
      pendencia?.codigo || pendencia?.codigoProcesso || pendencia?.destino?.codigo || pendencia?.destino?.entidadeId || pendencia?.entidadeId || "";

    const texto = String(codigo).trim();

    return texto ? texto.toUpperCase() : "—";
  };

  const solicitantePendencia = (pendencia) => {
    const solicitante =
      pendencia?.solicitante?.nome ||
      pendencia?.solicitanteNome ||
      pendencia?.usuarioSolicitante?.nome ||
      pendencia?.usuarioSolicitanteNome ||
      pendencia?.criadoPor?.nome ||
      pendencia?.questionadoPor?.nome ||
      "";

    return String(solicitante).trim() || "—";
  };

  const naVezDePendencia = (pendencia) => {
    const recebidoBackend = pendencia?.naVezDe || pendencia?.atuandoComo || pendencia?.papelAtual || "";

    if (String(recebidoBackend).trim()) {
      return String(recebidoBackend).trim();
    }

    const setorRepresentante =
      pendencia?.setorRepresentante?.nome ||
      pendencia?.setorRepresentante ||
      pendencia?.aprovador?.setor?.nome ||
      pendencia?.aprovadorSetor ||
      pendencia?.setor?.nome ||
      pendencia?.departamento?.nome ||
      "";

    if (String(setorRepresentante).trim()) {
      return `Você — ${String(setorRepresentante).trim()}`;
    }

    return "Você";
  };

  const chaveInteracao = (pendencia) => {
    return (
      pendencia?.chave ||
      `${pendencia?.destino?.processoTipo || pendencia?.processoTipo || "processo"}-${
        pendencia?.destino?.entidadeId || pendencia?.entidadeId || "0"
      }-${pendencia?.tipo || "interacao"}`
    );
  };

  /*
   * =====================================================
   * SITUAÇÃO VISUAL DA INTERAÇÃO
   * =====================================================
   */

  const estadoVisualInteracao = (pendencia) => {
    const chave = chaveInteracao(pendencia);

    let estado = normalizar(
      pendencia?.situacaoVisual || pendencia?.estadoInteracao || pendencia?.statusInteracao || pendencia?.estado_visual || "",
    ).toUpperCase();

    if (estado === "NOVO" && itensVisualizados[chave]) {
      estado = "VISTO";
    }

    if (!estado) {
      const categoria = situacaoInteracao(pendencia);

      if (categoria === "REPROVAÇÃO") {
        estado = "REPROVADO";
      } else if (categoria === "REVISÃO") {
        estado = "REVISAO";
      } else if (categoria === "ASSINATURA") {
        estado = "ASSINATURA";
      } else if (pendencia?.respondido === true || pendencia?.dataResposta) {
        estado = "RESPONDIDO";
      } else if (pendencia?.visualizado === true || pendencia?.visto === true || pendencia?.dataVisualizacao || itensVisualizados[chave]) {
        estado = "VISTO";
      } else {
        estado = "NOVO";
      }
    }

    switch (estado) {
      case "VISTO":
      case "VISUALIZADO":
        return {
          nome: "Visto",
          cor: "bg-[#eab308]",
          borda: "border-[#eab308]",
          linha: "bg-[#eab308]/15 hover:bg-[#eab308]/20",
        };

      case "QUESTIONADO":
      case "QUESTIONAMENTO":
        return {
          nome: "Questionamento",
          cor: "bg-[#a855f7]",
          borda: "border-[#a855f7]",
          linha: "bg-[#a855f7]/15 hover:bg-[#a855f7]/20",
        };

      case "RESPONDIDO":
        return {
          nome: "Respondido",
          cor: "bg-[#2196f3]",
          borda: "border-[#2196f3]",
          linha: "bg-[#2196f3]/15 hover:bg-[#2196f3]/20",
        };

      case "REVISAO":
      case "REVISADO":
      case "EM REVISAO":
        return {
          nome: "Revisão",
          cor: "bg-[#f97316]",
          borda: "border-[#f97316]",
          linha: "bg-[#f97316]/15 hover:bg-[#f97316]/20",
        };

      case "REPROVADO":
      case "REPROVACAO":
      case "DEVOLVIDO":
      case "DEVOLVIDA":
        return {
          nome: "Reprovado / Devolvido",
          cor: "bg-[#ef4444]",
          borda: "border-[#ef4444]",
          linha: "bg-[#ef4444]/15 hover:bg-[#ef4444]/20",
        };

      case "ASSINATURA":
      case "ASSINAR":
      case "AGUARDANDO ASSINATURA":
        return {
          nome: "Assinatura",
          cor: "bg-[#06b6d4]",
          borda: "border-[#06b6d4]",
          linha: "bg-[#06b6d4]/15 hover:bg-[#06b6d4]/20",
        };

      case "APROVADO":
        return {
          nome: "Visto",
          cor: "bg-[#eab308]",
          borda: "border-[#eab308]",
          linha: "bg-[#eab308]/15 hover:bg-[#eab308]/20",
        };

      case "NOVO":
      default:
        return {
          nome: "Novo",
          cor: "bg-transparent",
          borda: "border-[color:var(--ig-b-6b7280)]",
          linha: "bg-transparent hover:bg-[color:var(--ig-f-181f31)]",
        };
    }
  };

  const estadoVisualAcaoRealizada = (registro) => {
    const acao = acaoRealizadaRegistro(registro);

    switch (acao) {
      case "APROVADO":
        return {
          nome: "Aprovado",
          cor: "bg-[#22c55e]",
          borda: "border-[#22c55e]",
          linha: "bg-[#22c55e]/15 hover:bg-[#22c55e]/20",
        };

      case "REPROVADO":
        return {
          nome: "Reprovado",
          cor: "bg-[#ef4444]",
          borda: "border-[#ef4444]",
          linha: "bg-[#ef4444]/15 hover:bg-[#ef4444]/20",
        };

      case "QUESTIONADO":
        return {
          nome: "Questionado",
          cor: "bg-[#a855f7]",
          borda: "border-[#a855f7]",
          linha: "bg-[#a855f7]/15 hover:bg-[#a855f7]/20",
        };

      case "RESPONDIDO":
        return {
          nome: "Respondido",
          cor: "bg-[#2196f3]",
          borda: "border-[#2196f3]",
          linha: "bg-[#2196f3]/15 hover:bg-[#2196f3]/20",
        };

      case "REVISADO":
        return {
          nome: "Revisado",
          cor: "bg-[#f97316]",
          borda: "border-[#f97316]",
          linha: "bg-[#f97316]/15 hover:bg-[#f97316]/20",
        };

      case "ASSINADO":
        return {
          nome: "Assinado",
          cor: "bg-[#06b6d4]",
          borda: "border-[#06b6d4]",
          linha: "bg-[#06b6d4]/15 hover:bg-[#06b6d4]/20",
        };

      default:
        return {
          nome: "Realizado",
          cor: "bg-[#6b7280]",
          borda: "border-[color:var(--ig-b-6b7280)]",
          linha: "bg-transparent hover:bg-[color:var(--ig-f-181f31)]",
        };
    }
  };

  /*
   * =====================================================
   * SITUAÇÃO VISUAL - ASSINATURAS
   * =====================================================
   */

  const estadoVisualAssinatura = (registro) => {
    switch (registro?.__assinaturaStatus) {
      case "PENDENTE":
        return {
          nome: "Pendente",
          cor: "bg-[#ffb347]",
          borda: "border-[#ffb347]",
          linha: "bg-[#ffb347]/15 hover:bg-[#ffb347]/20",
        };

      case "AGUARDANDO":
        return {
          nome: "Aguardando",
          cor: "bg-[#2889df]",
          borda: "border-[#2889df]",
          linha: "bg-[#2889df]/15 hover:bg-[#2889df]/20",
        };

      case "ASSINADO":
        return {
          nome: "Assinado",
          cor: "bg-[#218c5a]",
          borda: "border-[#218c5a]",
          linha: "bg-[#218c5a]/15 hover:bg-[#218c5a]/20",
        };

      case "RECUSADO":
        return {
          nome: "Recusado",
          cor: "bg-[#e53935]",
          borda: "border-[#e53935]",
          linha: "bg-[#e53935]/15 hover:bg-[#e53935]/20",
        };

      default:
        return {
          nome: "Assinatura",
          cor: "bg-[#6b7280]",
          borda: "border-[color:var(--ig-b-6b7280)]",
          linha: "bg-transparent hover:bg-[color:var(--ig-f-181f31)]",
        };
    }
  };

  const estadoVisualRegistro = (registro) => {
    if (visaoSelecionada === "HISTORICOS") {
      return estadoVisualAcaoRealizada(registro);
    }

    if (visaoSelecionada === "ASSINATURAS") {
      return estadoVisualAssinatura(registro);
    }

    return estadoVisualInteracao(registro);
  };

  const temDestinoValido = (pendencia) => {
    const rota = String(pendencia?.destino?.rota || pendencia?.rota || "").trim();

    if (rota) {
      return true;
    }

    const entidadeId = Number(pendencia?.destino?.entidadeId ?? pendencia?.entidadeId);

    if (!Number.isInteger(entidadeId) || entidadeId <= 0) {
      return false;
    }

    const processoTipo = String(pendencia?.destino?.processoTipo || pendencia?.processoTipo || "")
      .trim()
      .toLowerCase();

    return ["proposta", "fichas", "analisecredito", "contrato"].includes(processoTipo);
  };

  const registrosDaCategoria = useMemo(() => {
    if (categoriaSelecionada === "TODOS") {
      return registrosVisaoAtual;
    }

    return registrosVisaoAtual.filter((registro) => {
      if (visaoSelecionada === "HISTORICOS") {
        return acaoRealizadaRegistro(registro) === categoriaSelecionada;
      }

      if (visaoSelecionada === "ASSINATURAS") {
        return registro.__assinaturaStatus === categoriaSelecionada;
      }

      return situacaoInteracao(registro) === categoriaSelecionada;
    });
  }, [registrosVisaoAtual, categoriaSelecionada, visaoSelecionada]);

  const correspondeFiltroColuna = (valor, filtro) => {
    if (!String(filtro || "").trim()) {
      return true;
    }

    return normalizar(valor).includes(normalizar(filtro));
  };

  const pendenciasFiltradas = useMemo(() => {
    return registrosDaCategoria.filter((pendencia) => {
      const tipo = situacaoInteracao(pendencia);

      const situacao = estadoVisualRegistro(pendencia).nome;

      const processo = nomeProcesso(pendencia);

      const codigo = codigoPendencia(pendencia);

      const descricao = descricaoPendencia(pendencia);

      const solicitante = solicitantePendencia(pendencia);

      const naVezDe = naVezDePendencia(pendencia);

      const identificacao = identificacaoRegistro(pendencia);

      const dataPendencia = obterDataPendencia(pendencia);

      if (filtroSituacao && situacao !== filtroSituacao) {
        return false;
      }

      if (filtroProcesso && processo !== filtroProcesso) {
        return false;
      }

      if (filtroPesquisa.trim()) {
        const pesquisa = normalizar(filtroPesquisa);

        const conteudo = normalizar([situacao, tipo, processo, codigo, descricao, solicitante, naVezDe, identificacao, pendencia?.imovel?.endereco].join(" "));

        if (!conteudo.includes(pesquisa)) {
          return false;
        }
      }

      const valoresPorColuna = {
        SITUACAO: situacao,
        TIPO: tipo,
        PROCESSO: processo,
        CODIGO: codigo,
        DESCRICAO: descricao,
        SOLICITANTE: solicitante,
        NA_VEZ_DE: naVezDe,
        IMOVEL_LOCATARIO: identificacao,
        ATUALIZADO: `
  ${formatarDataParaFiltro(dataPendencia)}
  ${formatarDataRelativa(dataPendencia)}
  ${formatarDataHora(dataPendencia)}
`,
      };

      const naoCorrespondeAosFiltrosDaGrid = Object.entries(filtrosColuna).some(([coluna, filtro]) => {
        if (!String(filtro || "").trim()) {
          return false;
        }

        return !correspondeFiltroColuna(valoresPorColuna[coluna], filtro);
      });

      if (naoCorrespondeAosFiltrosDaGrid) {
        return false;
      }

      if (dataInicial) {
        if (!dataPendencia) {
          return false;
        }

        const dataRegistro = new Date(dataPendencia);

        const inicio = new Date(`${dataInicial}T00:00:00`);

        if (!Number.isNaN(dataRegistro.getTime()) && dataRegistro < inicio) {
          return false;
        }
      }

      if (dataFinal) {
        if (!dataPendencia) {
          return false;
        }

        const dataRegistro = new Date(dataPendencia);

        const fim = new Date(`${dataFinal}T23:59:59`);

        if (!Number.isNaN(dataRegistro.getTime()) && dataRegistro > fim) {
          return false;
        }
      }

      return true;
    });
  }, [registrosDaCategoria, filtroSituacao, filtroProcesso, filtroPesquisa, dataInicial, dataFinal, filtrosColuna, itensVisualizados]);

  /*
   * =====================================================
   * ORDENAÇÃO DA TABELA
   * =====================================================
   */

  const alterarOrdenacao = (coluna) => {
    const configuracao = COLUNAS_CENTRAL_MAPA[coluna];

    if (!configuracao?.ordenavel) {
      return;
    }

    if (colunaOrdenacao === coluna) {
      setDirecaoOrdenacao((direcaoAtual) => (direcaoAtual === "ASC" ? "DESC" : "ASC"));

      return;
    }

    setColunaOrdenacao(coluna);
    setDirecaoOrdenacao("ASC");
  };

  const compararTexto = (a, b) =>
    String(a || "").localeCompare(String(b || ""), "pt-BR", {
      sensitivity: "base",
      numeric: true,
    });

  const pendenciasOrdenadas = useMemo(() => {
    const lista = [...pendenciasFiltradas];

    lista.sort((a, b) => {
      let valorA = "";
      let valorB = "";

      switch (colunaOrdenacao) {
        case "SITUACAO":
          valorA = estadoVisualRegistro(a).nome;
          valorB = estadoVisualRegistro(b).nome;
          break;

        case "TIPO":
          valorA = situacaoInteracao(a);
          valorB = situacaoInteracao(b);
          break;

        case "PROCESSO":
          valorA = nomeProcesso(a);
          valorB = nomeProcesso(b);
          break;

        case "CODIGO":
          valorA = codigoPendencia(a);
          valorB = codigoPendencia(b);
          break;

        case "DESCRICAO":
          valorA = descricaoPendencia(a);
          valorB = descricaoPendencia(b);
          break;

        case "SOLICITANTE":
          valorA = solicitantePendencia(a);
          valorB = solicitantePendencia(b);
          break;

        case "NA_VEZ_DE":
          valorA = naVezDePendencia(a);
          valorB = naVezDePendencia(b);
          break;

        case "IMOVEL_LOCATARIO":
          valorA = identificacaoRegistro(a);
          valorB = identificacaoRegistro(b);
          break;

        case "ATUALIZADO": {
          const dataA = obterDataPendencia(a);

          const dataB = obterDataPendencia(b);

          valorA = dataA ? new Date(dataA).getTime() : 0;

          valorB = dataB ? new Date(dataB).getTime() : 0;

          break;
        }

        default:
          return 0;
      }

      let resultado;

      if (colunaOrdenacao === "ATUALIZADO") {
        resultado = valorA - valorB;
      } else {
        resultado = compararTexto(valorA, valorB);
      }

      return direcaoOrdenacao === "ASC" ? resultado : -resultado;
    });

    return lista;
  }, [pendenciasFiltradas, colunaOrdenacao, direcaoOrdenacao, itensVisualizados]);

  /*
   * =====================================================
   * PAGINAÇÃO
   * =====================================================
   */

  const totalRegistros = pendenciasOrdenadas.length;

  const totalPaginas = Math.max(1, Math.ceil(totalRegistros / registrosPorPagina));

  const paginaSegura = Math.min(paginaAtual, totalPaginas);

  const indiceInicial = totalRegistros === 0 ? 0 : (paginaSegura - 1) * registrosPorPagina;

  const indiceFinal = Math.min(indiceInicial + registrosPorPagina, totalRegistros);

  const pendenciasPaginadas = useMemo(() => {
    return pendenciasOrdenadas.slice(indiceInicial, indiceFinal);
  }, [pendenciasOrdenadas, indiceInicial, indiceFinal]);

  useEffect(() => {
    if (paginaAtual > totalPaginas) {
      setPaginaAtual(totalPaginas);
    }
  }, [paginaAtual, totalPaginas]);

  useEffect(() => {
    setPaginaAtual(1);
  }, [categoriaSelecionada, filtroSituacao, filtroProcesso, filtroPesquisa, dataInicial, dataFinal, filtrosColuna, registrosPorPagina]);

  const paginaAnterior = () => {
    setPaginaAtual((pagina) => Math.max(1, pagina - 1));
  };

  const proximaPagina = () => {
    setPaginaAtual((pagina) => Math.min(totalPaginas, pagina + 1));
  };

  const alterarRegistrosPorPagina = (quantidade) => {
    setRegistrosPorPagina(quantidade);
    setPaginaAtual(1);
    setSeletorPaginaAberto(false);
  };

  const alterarAprovadoresPorPagina = (quantidade) => {
    setAprovadoresPorPagina(quantidade);
    setPaginaAprovadores(1);
    setSeletorAprovadoresPaginaAberto(false);
  };

  const paginaAnteriorAprovadores = () => {
    setPaginaAprovadores((pagina) => Math.max(1, pagina - 1));
  };

  const proximaPaginaAprovadores = () => {
    setPaginaAprovadores((pagina) => Math.min(totalPaginasAprovadores, pagina + 1));
  };

  const indicadorOrdenacao = (coluna) => {
    if (colunaOrdenacao !== coluna) {
      return <span className="ml-1 text-gray-600">↕</span>;
    }

    return <span className="ml-1 text-[#2196f3]">{direcaoOrdenacao === "ASC" ? "▲" : "▼"}</span>;
  };

  const alterarFiltroColuna = (coluna, valor) => {
    setFiltrosColuna((estadoAtual) => ({
      ...estadoAtual,
      [coluna]: valor,
    }));
  };

  const limparFiltroColuna = (coluna) => {
    setFiltrosColuna((estadoAtual) => ({
      ...estadoAtual,
      [coluna]: "",
    }));
  };

  const iniciarArrasteColuna = (event, coluna) => {
    setColunaArrastada(coluna);

    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", coluna);
  };

  const soltarColuna = (event, colunaDestino) => {
    event.preventDefault();

    if (!colunaArrastada || colunaArrastada === colunaDestino) {
      setColunaArrastada("");
      return;
    }

    setConfiguracaoGrid((estadoAtual) => {
      const novaOrdem = [...estadoAtual.ordem];

      const indiceOrigem = novaOrdem.indexOf(colunaArrastada);

      const indiceDestino = novaOrdem.indexOf(colunaDestino);

      if (indiceOrigem < 0 || indiceDestino < 0) {
        return estadoAtual;
      }

      novaOrdem.splice(indiceOrigem, 1);

      novaOrdem.splice(indiceDestino, 0, colunaArrastada);

      return {
        ...estadoAtual,
        ordem: novaOrdem,
      };
    });

    setColunaArrastada("");
  };

  const iniciarRedimensionamento = (event, coluna) => {
    event.preventDefault();
    event.stopPropagation();

    const configuracao = COLUNAS_CENTRAL_MAPA[coluna];

    if (!configuracao) {
      return;
    }

    const inicioX = event.clientX;

    const larguraInicial = largurasColunas[coluna] || configuracao.largura;

    const mover = (eventoMovimento) => {
      const diferenca = eventoMovimento.clientX - inicioX;

      const novaLargura = Math.max(configuracao.min, larguraInicial + diferenca);

      setConfiguracaoGrid((estadoAtual) => ({
        ...estadoAtual,
        larguras: {
          ...estadoAtual.larguras,
          [coluna]: novaLargura,
        },
      }));
    };

    const finalizar = () => {
      window.removeEventListener("mousemove", mover);

      window.removeEventListener("mouseup", finalizar);
    };

    window.addEventListener("mousemove", mover);

    window.addEventListener("mouseup", finalizar);
  };

  const larguraTotalGrid = ordemColunas.reduce((total, chave) => {
    const coluna = COLUNAS_CENTRAL_MAPA[chave];

    return total + Number(largurasColunas[chave] || coluna?.largura || 100);
  }, 0);

  const limparFiltros = () => {
    setCategoriaSelecionada("TODOS");

    setFiltroSituacao("");
    setFiltroProcesso("");
    setFiltroPesquisa("");

    setDataInicial("");
    setDataFinal("");

    setFiltrosColuna({
      ...FILTROS_COLUNA_VAZIOS,
    });

    setFiltroColunaAberto("");

    setPaginaAtual(1);
  };

  const alterarVisao = (novaVisao) => {
    if (novaVisao === visaoSelecionada) {
      return;
    }

    setVisaoSelecionada(novaVisao);

    setCategoriaSelecionada("TODOS");

    setFiltroSituacao("");
    setFiltroProcesso("");
    setFiltroPesquisa("");

    setDataInicial("");
    setDataFinal("");

    setFiltrosColuna({
      ...FILTROS_COLUNA_VAZIOS,
    });

    setFiltroColunaAberto("");

    setPaginaAtual(1);
  };

  /*
   * =====================================================
   * COPIAR
   * =====================================================
   */

  const copiarTabela = async () => {
    if (pendenciasFiltradas.length === 0) {
      alert("Não há registros para copiar.");
      return;
    }

    const linhas = pendenciasFiltradas.map((pendencia) =>
      [
        estadoVisualRegistro(pendencia).nome,
        situacaoInteracao(pendencia),
        nomeProcesso(pendencia),
        codigoPendencia(pendencia),
        descricaoPendencia(pendencia),
        solicitantePendencia(pendencia),
        naVezDePendencia(pendencia),
        identificacaoRegistro(pendencia),
        formatarDataHora(obterDataPendencia(pendencia)),
      ].join("\t"),
    );

    const conteudo = [
      ["SITUAÇÃO", "TIPO", "PROCESSO", "CÓDIGO", "DESCRIÇÃO", "SOLICITANTE", "NA VEZ DE", "IMÓVEL / LOCATÁRIO", "ATUALIZADO"].join("\t"),
      ...linhas,
    ].join("\n");

    try {
      await navigator.clipboard.writeText(conteudo);
    } catch (err) {
      console.error("Erro ao copiar Central de Interações:", err);

      alert("Não foi possível copiar os registros.");
    }
  };

  /*
   * =====================================================
   * CSV
   * =====================================================
   */

  const escaparCsv = (valor) => {
    const texto = String(valor ?? "").replace(/"/g, '""');

    return `"${texto}"`;
  };

  const exportarCsv = () => {
    if (pendenciasFiltradas.length === 0) {
      alert("Não há registros para exportar.");
      return;
    }

    const cabecalho = ["SITUAÇÃO", "TIPO", "PROCESSO", "CÓDIGO", "DESCRIÇÃO", "SOLICITANTE", "NA VEZ DE", "IMÓVEL / LOCATÁRIO", "ATUALIZADO"];

    const linhas = pendenciasFiltradas.map((pendencia) => [
      estadoVisualRegistro(pendencia).nome,
      situacaoInteracao(pendencia),
      nomeProcesso(pendencia),
      codigoPendencia(pendencia),
      descricaoPendencia(pendencia),
      solicitantePendencia(pendencia),
      naVezDePendencia(pendencia),
      identificacaoRegistro(pendencia),
      formatarDataHora(obterDataPendencia(pendencia)),
    ]);

    const csv = [cabecalho, ...linhas].map((linha) => linha.map(escaparCsv).join(";")).join("\n");

    const blob = new Blob([`\uFEFF${csv}`], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = "central-interacoes.csv";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  /*
   * =====================================================
   * MARCAR COMO VISTO
   * =====================================================
   */

  const marcarComoVisto = async (pendencia) => {
    if (!pendencia) {
      return;
    }

    const situacaoAtual = estadoVisualInteracao(pendencia);

    if (situacaoAtual.nome !== "Novo") {
      return;
    }

    const chave = chaveInteracao(pendencia);

    const token = getToken();

    if (!token) {
      console.error("Central de Interação: sessão não identificada para registrar visualização.");

      return;
    }

    try {
      const response = await fetch("/api/pendencias-aprovacao/visualizar", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },

        body: JSON.stringify({
          chave,
        }),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }

      const resultado = await response.json();

      setItensVisualizados((estadoAtual) => ({
        ...estadoAtual,
        [chave]: true,
      }));

      if (!usandoDadosExternos) {
        setPendenciasInternas((estadoAtual) =>
          estadoAtual.map((item) => {
            if (chaveInteracao(item) !== chave) {
              return item;
            }

            return {
              ...item,
              situacaoVisual: "VISTO",
              visualizado: true,
              dataVisualizacao: resultado?.visualizadoEm || new Date().toISOString(),
            };
          }),
        );
      }
    } catch (error) {
      console.error("Central de Interação: não foi possível marcar a interação como vista.", error);
    }
  };

  /*
   * =====================================================
   * ABRIR PENDÊNCIA
   * =====================================================
   */

  const abrirPendencia = async (pendencia) => {
    if (!pendencia) {
      console.error("Central de Interação: pendência não informada.");

      return;
    }

    await marcarComoVisto(pendencia);

    const rotaDestino = String(pendencia?.destino?.rota || pendencia?.rota || "").trim();

    const entidadeId = Number(pendencia?.destino?.entidadeId ?? pendencia?.entidadeId);

    if ((!Number.isInteger(entidadeId) || entidadeId <= 0) && !rotaDestino) {
      console.error("Central de Interação: destino inválido.", pendencia);

      return;
    }

    const processoTipo = String(pendencia?.destino?.processoTipo || pendencia?.processoTipo || "")
      .trim()
      .toLowerCase();

    const codigo = String(pendencia?.codigo || "").trim();

    const esperar = (localizar, limiteMs = 15000) =>
      new Promise((resolve, reject) => {
        const inicio = Date.now();

        const verificar = () => {
          try {
            const resultado = localizar();

            if (resultado) {
              resolve(resultado);
              return;
            }
          } catch (err) {
            console.error("Central de Interação: erro durante espera.", err);
          }

          if (Date.now() - inicio >= limiteMs) {
            reject(new Error("Destino da pendência não ficou disponível."));
            return;
          }

          setTimeout(verificar, 150);
        };

        verificar();
      });

    const clicar = (elemento) => {
      if (!elemento) {
        return;
      }

      elemento.scrollIntoView({
        behavior: "auto",
        block: "center",
      });

      elemento.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
    };

    const localizarAba = (nome) => {
      const procurado = normalizar(nome);

      return Array.from(document.querySelectorAll('[role="tab"]')).find((tab) => normalizar(tab.textContent) === procurado);
    };

    const focarAcao = async (tipoPendencia) => {
      const textoAcao = tipoPendencia === "RESPONDER" ? "responder" : "aprovar";

      try {
        const botao = await esperar(() => {
          return Array.from(document.querySelectorAll("button")).find((item) => {
            const texto = normalizar(item.textContent);

            return texto === textoAcao || texto.startsWith(`${textoAcao} `);
          });
        }, 5000);

        botao.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } catch {
        // Não bloqueia a navegação.
      }
    };

    if (modoOverlay && typeof onFechar === "function") {
      onFechar();
    }

    try {
      if (processoTipo === "fichas") {
        navigate(`/ficha-cadastro?proposta=${entidadeId}`);

        await esperar(() => {
          if (window.location.pathname !== "/ficha-cadastro") {
            return null;
          }

          const params = new URLSearchParams(window.location.search);

          if (Number(params.get("proposta")) !== entidadeId) {
            return null;
          }

          const textoPagina = normalizar(document.body.innerText);

          const fichaCarregada = textoPagina.includes(normalizar("Visualizar Ficha de Cadastro")) || textoPagina.includes(normalizar("Ficha de Cadastro"));

          return fichaCarregada ? true : null;
        });

        const abaAprovacao = await esperar(() => localizarAba("Aprovação das Fichas"), 15000);

        clicar(abaAprovacao);

        const inicio = Date.now();

        while (Date.now() - inicio < 3500) {
          const aba = localizarAba("Aprovação das Fichas");

          if (aba) {
            const selecionada = aba.getAttribute("aria-selected") === "true" || aba.classList.contains("Mui-selected");

            if (!selecionada) {
              clicar(aba);
            }
          }

          await new Promise((resolve) => setTimeout(resolve, 250));
        }

        await focarAcao(pendencia.tipo);

        return;
      }

      if (processoTipo === "analisecredito") {
        navigate(`/ficha-cadastro?proposta=${entidadeId}`);

        await esperar(() => {
          if (window.location.pathname !== "/ficha-cadastro") {
            return null;
          }

          const params = new URLSearchParams(window.location.search);

          if (Number(params.get("proposta")) !== entidadeId) {
            return null;
          }

          const textoPagina = normalizar(document.body.innerText);

          const fichaCarregada = textoPagina.includes(normalizar("Visualizar Ficha de Cadastro")) || textoPagina.includes(normalizar("Ficha de Cadastro"));

          return fichaCarregada ? true : null;
        }, 5000);

        const abaAprovacaoAnalise = await esperar(() => localizarAba("Aprovação da Análise de Crédito"), 5000);

        clicar(abaAprovacaoAnalise);

        const inicio = Date.now();

        while (Date.now() - inicio < 3000) {
          const aba = localizarAba("Aprovação da Análise de Crédito");

          if (aba) {
            const selecionada = aba.getAttribute("aria-selected") === "true" || aba.classList.contains("Mui-selected");

            if (!selecionada) {
              clicar(aba);
            }
          }

          await new Promise((resolve) => setTimeout(resolve, 250));
        }

        await focarAcao(pendencia.tipo);

        return;
      }

      if (processoTipo === "proposta") {
        navigate("/proposta-comercial");

        const campoFiltro = await esperar(() => {
          if (window.location.pathname !== "/proposta-comercial") {
            return null;
          }

          return Array.from(document.querySelectorAll("input")).find((input) => {
            const placeholder = normalizar(input.getAttribute("placeholder"));

            return placeholder.startsWith(normalizar("Filtrar Propostas Comerciais"));
          });
        }, 5000);

        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;

        if (setter) {
          setter.call(campoFiltro, codigo);
        } else {
          campoFiltro.value = codigo;
        }

        campoFiltro.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
            bubbles: true,
            cancelable: true,
          }),
        );

        const linha = await esperar(() => {
          const codigoNormalizado = normalizar(codigo);

          return Array.from(document.querySelectorAll("tbody tr")).find((tr) => normalizar(tr.textContent).includes(codigoNormalizado));
        }, 5000);

        const primeiraCelula = linha.querySelector("td");

        const botaoVisualizar = primeiraCelula?.querySelector("button");

        if (!botaoVisualizar) {
          throw new Error(`Botão Visualizar não encontrado para ${codigo}.`);
        }

        clicar(botaoVisualizar);

        await esperar(() => {
          const textoPagina = normalizar(document.body.innerText);

          return textoPagina.includes(normalizar("Visualizar Proposta")) && textoPagina.includes(normalizar(codigo));
        }, 5000);

        const abaAprovacao = await esperar(() => localizarAba("Aprovação"), 5000);

        clicar(abaAprovacao);

        await esperar(() => {
          const aba = localizarAba("Aprovação");

          return aba && (aba.getAttribute("aria-selected") === "true" || aba.classList.contains("Mui-selected"));
        }, 3000);

        await focarAcao(pendencia.tipo);

        return;
      }

      if (processoTipo === "contrato") {
        navigate("/contratos");

        const campoFiltro = await esperar(() => {
          if (window.location.pathname !== "/contratos") {
            return null;
          }

          return Array.from(document.querySelectorAll("input")).find((input) =>
            normalizar(input.getAttribute("placeholder")).startsWith(normalizar("Filtrar Contrato")),
          );
        }, 5000);

        /*
         * O Dashboard trabalha sobre a Proposta.
         * Na tela de Contratos, a PC vinculada aparece na linha.
         * Então filtramos pelo código da PC.
         */
        const valorBusca = codigo;

        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;

        if (setter) {
          setter.call(campoFiltro, valorBusca);
        } else {
          campoFiltro.value = valorBusca;
        }

        campoFiltro.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
            bubbles: true,
            cancelable: true,
          }),
        );

        const linha = await esperar(() => {
          const codigoNormalizado = normalizar(valorBusca);

          return Array.from(document.querySelectorAll("tbody tr")).find((tr) => normalizar(tr.textContent).includes(codigoNormalizado));
        }, 5000);

        const primeiraCelula = linha.querySelector("td");

        const botaoVisualizar = primeiraCelula?.querySelector("button");

        if (!botaoVisualizar) {
          throw new Error(`Contrato da proposta ${codigo} não encontrado.`);
        }

        clicar(botaoVisualizar);

        /*
         * Se a pendência for de aprovação,
         * posiciona diretamente na aba APROVAÇÃO.
         */
        if (pendencia.tipo === "APROVAR") {
          const abaAprovacao = await esperar(() => localizarAba("Aprovação"), 5000);

          clicar(abaAprovacao);

          await focarAcao(pendencia.tipo);
        }

        return;
      }
      if (processoTipo === "alteracaocontratual") {
        navigate("/alteracoes-contratuais/processos");

        const campoFiltroAlteracao = await esperar(() => {
          if (window.location.pathname !== "/alteracoes-contratuais/processos") {
            return null;
          }

          return Array.from(document.querySelectorAll("input")).find((input) =>
            normalizar(input.getAttribute("placeholder")).startsWith(normalizar("Filtrar Alteração")),
          );
        }, 5000);

        const empresaBusca = String(pendencia?.empresaApelido || "").trim();

        const setterAlteracao = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;

        if (setterAlteracao) {
          setterAlteracao.call(campoFiltroAlteracao, empresaBusca);
        } else {
          campoFiltroAlteracao.value = empresaBusca;
        }

        campoFiltroAlteracao.dispatchEvent(new Event("input", { bubbles: true }));
        campoFiltroAlteracao.dispatchEvent(new Event("change", { bubbles: true }));
        campoFiltroAlteracao.dispatchEvent(
          new KeyboardEvent("keydown", { key: "Enter", code: "Enter", keyCode: 13, which: 13, bubbles: true, cancelable: true }),
        );

        // Linha da empresa com a mesma identificação da alteração (coluna "Identificação").
        const identificacaoTexto = normalizar(pendencia?.identificacaoTexto || "");

        const linhaAlteracao = await esperar(() => {
          const empresaNormalizada = normalizar(empresaBusca);

          return Array.from(document.querySelectorAll("tbody tr")).find((tr) => {
            const texto = normalizar(tr.textContent);

            return texto.includes(empresaNormalizada) && (!identificacaoTexto || texto.includes(identificacaoTexto));
          });
        }, 5000);

        const botaoVisualizarAlteracao = linhaAlteracao.querySelector("td")?.querySelector("button");

        if (!botaoVisualizarAlteracao) {
          throw new Error(`Alteração ${codigo} não encontrada.`);
        }

        clicar(botaoVisualizarAlteracao);

        // Abre a aba Fluxo, onde a etapa é avançada.
        try {
          const abaFluxo = await esperar(() => localizarAba("Fluxo"), 3000);

          clicar(abaFluxo);
        } catch {
          // a aba é opcional; o registro já está aberto
        }

        return;
      }

      if (processoTipo === "templatecontrato") {
        navigate("/templates");

        const campoFiltro = await esperar(() => {
          if (window.location.pathname !== "/templates") {
            return null;
          }

          return Array.from(document.querySelectorAll("input")).find((input) =>
            normalizar(input.getAttribute("placeholder")).startsWith(normalizar("Filtrar Template")),
          );
        }, 5000);

        const valorBusca = codigo;

        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;

        if (setter) {
          setter.call(campoFiltro, valorBusca);
        } else {
          campoFiltro.value = valorBusca;
        }

        campoFiltro.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );

        campoFiltro.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
            bubbles: true,
            cancelable: true,
          }),
        );

        const linha = await esperar(() => {
          const codigoNormalizado = normalizar(valorBusca);

          return Array.from(document.querySelectorAll("tbody tr")).find((tr) => normalizar(tr.textContent).includes(codigoNormalizado));
        }, 5000);

        const primeiraCelula = linha.querySelector("td");

        const botaoVisualizar = primeiraCelula?.querySelector("button");

        if (!botaoVisualizar) {
          throw new Error(`Template ${codigo} não encontrado.`);
        }

        clicar(botaoVisualizar);

        if (pendencia.tipo === "APROVAR") {
          const abaAprovacao = await esperar(() => localizarAba("APROVAÇÃO"), 5000);

          clicar(abaAprovacao);

          await focarAcao(pendencia.tipo);
        }

        return;
      }

      if (processoTipo === "assinaturafinal" || processoTipo === "assinatura") {
        navigate("/assinatura-final");
        return;
      }

      console.error("Central de Interação: fluxo ainda não tratado.", {
        processoTipo,
        entidadeId,
        codigo,
      });
    } catch (err) {
      console.error("Central de Interação: não foi possível abrir a pendência corretamente.", {
        erro: err?.message || err,
        processoTipo,
        entidadeId,
        codigo,
        pendencia,
      });

      alert(`Não foi possível abrir automaticamente a pendência ${codigo}.`);
    }
  };

  /*
   * =====================================================
   * CORES
   * =====================================================
   */

  const estiloSituacao = (situacao) => {
    switch (situacao) {
      case "APROVAÇÃO":
        return "bg-[#0b4165] text-[#60b9f4] border-[#14618d]";

      case "QUESTIONAMENTO":
        return "bg-[#554006] text-[#facc15] border-[#755a08]";

      case "REVISÃO":
        return "bg-[#3b2164] text-[#c084fc] border-[#57308b]";

      case "REPROVAÇÃO":
        return "bg-[#571d1d] text-[#f87171] border-[#7f2929]";

      case "ASSINATURA":
        return "bg-[#48205f] text-[#d8b4fe] border-[#673182]";

      case "ANDAMENTO":
        return "bg-[#123d2c] text-[#4ade80] border-[#227447]";

      case "APROVADO":
        return "bg-[#123d2c] text-[#4ade80] border-[#227447]";

      case "REPROVADO":
        return "bg-[#571d1d] text-[#f87171] border-[#7f2929]";

      case "QUESTIONADO":
        return "bg-[#39205c] text-[#c084fc] border-[#67409a]";

      case "RESPONDIDO":
        return "bg-[#123b5a] text-[#60b9f4] border-[#1d6594]";

      case "REVISADO":
        return "bg-[#5a3213] text-[#fb923c] border-[#8a4c1d]";

      case "ASSINADO":
        return "bg-[#16424a] text-[#22d3ee] border-[#24717f]";

      default:
        return "bg-[#263244] text-gray-300 border-[color:var(--ig-b-3d4a5f)]";
    }
  };

  /*
   * =====================================================
   * CABEÇALHO DINÂMICO
   * =====================================================
   */

  const renderizarCabecalhoColuna = (chave) => {
    const coluna = COLUNAS_CENTRAL_MAPA[chave];

    if (!coluna) {
      return null;
    }

    const filtroAtivo = Boolean(String(filtrosColuna[chave] || "").trim());

    const largura = largurasColunas[chave] || coluna.largura;

    return (
      <th
        key={chave}
        draggable
        onDragStart={(event) => iniciarArrasteColuna(event, chave)}
        onDragOver={(event) => event.preventDefault()}
        onDrop={(event) => soltarColuna(event, chave)}
        onDragEnd={() => setColunaArrastada("")}
        style={{
          width: `${largura}px`,
          minWidth: `${coluna.min}px`,
        }}
        className="
          relative
          px-2
          py-3
          text-left
          text-[11px]
          font-semibold
          text-[color:var(--ig-t-6b7280)]
          uppercase
          select-none
          transition-colors
        "
        title="Arraste para reorganizar. Arraste a borda direita para redimensionar."
      >
        <div className="flex items-center gap-1.5 min-w-0">
          {coluna.ordenavel ? (
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                alterarOrdenacao(chave);
              }}
              className="
                flex
                items-center
                min-w-0
                hover:text-[color:var(--ig-t-d1d5db)]
                transition-colors
              "
            >
              <span className={chave === "ATUALIZADO" ? "whitespace-nowrap" : "truncate"}>{coluna.titulo}</span>

              {indicadorOrdenacao(chave)}
            </button>
          ) : (
            <span className="truncate">{coluna.titulo}</span>
          )}

          {coluna.filtravel && (
            <div className="relative" data-central-column-filter="true">
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation();

                  setFiltroColunaAberto((atual) => (atual === chave ? "" : chave));
                }}
                className={`
                  w-6
                  h-6
                  flex
                  items-center
                  justify-center
                  rounded
                  transition-colors
                  ${filtroAtivo ? "text-[#2196f3] bg-[#2196f3]/10" : "text-gray-600 hover:text-[color:var(--ig-t-d1d5db)] hover:bg-[color:var(--ig-f-202738)]"}
                `}
                title={`Filtrar ${coluna.titulo}`}
              >
                <FaFilter size={10} />
              </button>

              {filtroColunaAberto === chave && (
                <div
                  className="
                    absolute
                    z-[250]
                    top-[29px]
                    left-0
                    w-[250px]
                    p-3
                    rounded-md
                    border
                    border-[color:var(--ig-b-3d4658)]
                    bg-[color:var(--ig-f-202534)]
                    shadow-2xl
                    normal-case
                  "
                  onClick={(event) => event.stopPropagation()}
                >
                  <label className="block text-[10px] uppercase text-[color:var(--ig-t-6b7280)] mb-2">Filtrar {coluna.titulo}</label>

                  {chave === "ATUALIZADO" ? (
                    <input
                      autoFocus
                      type="date"
                      value={filtrosColuna[chave] || ""}
                      onChange={(event) => alterarFiltroColuna(chave, event.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Escape") {
                          setFiltroColunaAberto("");
                        }
                      }}
                      className="
                        w-full
                        h-9
                        px-3
                        rounded-md
                        border
                        border-[color:var(--ig-b-4b5568)]
                        bg-[color:var(--ig-f-111625)]
                        text-sm
                        text-[color:var(--ig-t-ffffff)]
                        outline-none
                        cursor-pointer
                        focus:border-[#2196f3]
                      "
                      style={{
                        colorScheme: "var(--ig-e-1txfa)",
                      }}
                    />
                  ) : (
                    <input
                      autoFocus
                      type="text"
                      value={filtrosColuna[chave] || ""}
                      onChange={(event) => alterarFiltroColuna(chave, event.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Escape") {
                          setFiltroColunaAberto("");
                        }
                      }}
                      placeholder={`Pesquisar em ${coluna.titulo.toLowerCase()}...`}
                      className="
                        w-full
                        h-9
                        px-3
                        rounded-md
                        border
                        border-[color:var(--ig-b-4b5568)]
                        bg-[color:var(--ig-f-111625)]
                        text-sm
                        text-[color:var(--ig-t-ffffff)]
                        placeholder-gray-600
                        outline-none
                        focus:border-[#2196f3]
                      "
                    />
                  )}

                  <div className="flex justify-end mt-2">
                    <button
                      type="button"
                      onClick={() => limparFiltroColuna(chave)}
                      className="
                        text-[11px]
                        text-[#2196f3]
                        hover:underline
                      "
                    >
                      Limpar
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <span
          onMouseDown={(event) => iniciarRedimensionamento(event, chave)}
          className="
            absolute
            right-0
            top-0
            w-[5px]
            h-full
            cursor-col-resize
            hover:bg-[#2196f3]/60
          "
          title="Redimensionar coluna"
        />
      </th>
    );
  };

  /*
   * =====================================================
   * CÉLULAS
   * =====================================================
   */

  const renderizarCelulaColuna = (chave, pendencia) => {
    const coluna = COLUNAS_CENTRAL_MAPA[chave];

    if (!coluna) {
      return null;
    }

    const largura = largurasColunas[chave] || coluna.largura;

    const situacao = visaoSelecionada === "HISTORICOS" ? acaoRealizadaRegistro(pendencia) : situacaoInteracao(pendencia);

    const indicador = estadoVisualRegistro(pendencia);

    let conteudo = null;

    switch (chave) {
      case "SITUACAO":
        conteudo = (
          <div className="flex items-center justify-center">
            <span
              className={`
                w-[9px]
                h-[9px]
                min-w-[9px]
                rounded-full
                border
                ${indicador.cor}
                ${indicador.borda}
              `}
              title={indicador.nome}
            />
          </div>
        );
        break;

      case "TIPO":
        conteudo = (
          <span
            className={`
              inline-flex
              w-max
              items-center
              justify-center
              px-2.5
              py-1
              rounded-md
              border
              text-[11px]
              font-semibold
              leading-4
              whitespace-nowrap
              box-border
              ${estiloSituacao(situacao)}
            `}
            title={situacao}
          >
            {situacao}
          </span>
        );
        break;

      case "PROCESSO": {
        const processo = nomeProcesso(pendencia);

        conteudo = (
          <span
            className="
              block
              max-w-full
              text-sm
              text-[color:var(--ig-t-d1d5db)]
              whitespace-normal
              break-words
              leading-5
            "
            title={processo}
          >
            {processo}
          </span>
        );

        break;
      }

      case "CODIGO":
        conteudo = <span className="text-sm font-bold text-[color:var(--ig-t-ffffff)] whitespace-nowrap">{codigoPendencia(pendencia)}</span>;
        break;

      case "DESCRICAO":
        conteudo = <span className="text-sm text-[color:var(--ig-t-d1d5db)] leading-5 break-words">{descricaoPendencia(pendencia)}</span>;
        break;

      case "SOLICITANTE":
        conteudo = <span className="text-sm text-[color:var(--ig-t-9ca3af)]">{solicitantePendencia(pendencia)}</span>;
        break;

      case "NA_VEZ_DE":
        conteudo = <span className="text-sm text-[color:var(--ig-t-9ca3af)]">{naVezDePendencia(pendencia)}</span>;
        break;

      case "IMOVEL_LOCATARIO": {
        const locatarioCompleto = nomeCompletoLocatario(pendencia);

        conteudo = (
          <span className="text-sm text-[color:var(--ig-t-9ca3af)] whitespace-nowrap" title={locatarioCompleto || undefined}>
            {identificacaoRegistro(pendencia)}
          </span>
        );

        break;
      }

      case "ATUALIZADO": {
        const data = obterDataPendencia(pendencia);

        conteudo = (
          <span
            className="
              block
              w-max
              text-sm
              text-[color:var(--ig-t-d1d5db)]
              whitespace-nowrap
            "
            title={formatarDataHora(data)}
          >
            {formatarDataHora(data)}
          </span>
        );

        break;
      }

      default:
        conteudo = "—";
    }

    return (
      <td
        key={chave}
        style={{
          width: `${largura}px`,
          minWidth: `${coluna.min}px`,
        }}
        className={`
          px-2
          py-3
          align-top
          text-left
          ${chave === "ATUALIZADO" ? "overflow-visible" : "overflow-hidden"}
        `}
      >
        {conteudo}
      </td>
    );
  };

  /*
   * =====================================================
   * RENDER
   * =====================================================
   */

  const dashboardEsteiraProposta = dashboardEsteiras.find((item) => item.chave === "PROPOSTA");

  const dashboardEsteiraFicha = dashboardEsteiras.find((item) => item.chave === "FICHA");

  const dashboardEsteiraAnalise = dashboardEsteiras.find((item) => item.chave === "ANALISE");

  const dashboardEsteiraContrato = dashboardEsteiras.find((item) => item.chave === "CONTRATO");

  const dashboardEsteiraTemplate = dashboardEsteiras.find((item) => item.chave === "TEMPLATE");

  const dashboardEsteiraAssinaturas = dashboardEsteiras.find((item) => item.chave === "ASSINATURAS");

  const dashboardEsteiraGeral = dashboardEsteiras.find((item) => item.chave === "GERAL");

  const atualizarPaginaCompleta = () => {
    window.location.reload();
  };

  const rolarParaSecao = (id) => {
    const elemento = document.getElementById(id);

    if (!elemento) {
      return;
    }

    elemento.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className={
        modoOverlay ? "fixed top-16 left-0 right-0 bottom-0 z-[90] bg-[color:var(--ig-f-0d111f)] overflow-x-hidden overflow-y-auto" : "w-full min-h-full"
      }
    >
      <div
        className={
          modoOverlay
            ? "min-h-full bg-[color:var(--ig-f-0d111f)] text-[color:var(--ig-t-ffffff)] px-6 py-5"
            : "w-full min-h-[calc(100vh-130px)] bg-[color:var(--ig-f-0d111f)] text-[color:var(--ig-t-ffffff)] px-6 py-5"
        }
      >
        {/* =================================================
            AÇÕES SUPERIORES
        ================================================= */}

        <div id="dashboard-home-topo" className="flex items-center justify-end gap-3 mb-3">
          <button
            type="button"
            onClick={() => rolarParaSecao("central-interacoes-secao")}
            className="
              w-11
              h-11
              flex
              items-center
              justify-center
              rounded-md
              border-2
              border-[#2196f3]
              bg-[#2196f3]/10
              text-[#42a5f5]
              hover:bg-[#2196f3]/20
              hover:text-[color:var(--ig-t-ffffff)]
              hover:border-[#42a5f5]
              transition-all
            "
            title="Ir para Central de Interações"
          >
            <FaChevronDown size={18} />
          </button>

          <button
            type="button"
            onClick={atualizarPaginaCompleta}
            className="
              h-9
              px-3
              flex
              items-center
              justify-center
              gap-2
              rounded-md
              border
              border-[color:var(--ig-b-30394c)]
              bg-[color:var(--ig-f-171d2c)]
              text-[color:var(--ig-t-d1d5db)]
              hover:text-[color:var(--ig-t-ffffff)]
              hover:bg-[color:var(--ig-f-222a3c)]
              transition-colors
            "
            title="Atualizar toda a página"
          >
            <FaSyncAlt size={14} />

            <span className="text-xs font-semibold">REFRESH</span>
          </button>

          {modoOverlay && (
            <button
              type="button"
              onClick={onFechar}
              className="
                w-9
                h-9
                p-0
                flex
                items-center
                justify-center
                rounded-md
                bg-[color:var(--ig-f-171d2c)]
                border
                border-[color:var(--ig-b-30394c)]
                text-[color:var(--ig-t-d1d5db)]
                hover:text-[color:var(--ig-t-ffffff)]
                hover:bg-[color:var(--ig-f-222a3c)]
                transition-colors
              "
              title="Fechar"
            >
              <FaTimes size={16} />
            </button>
          )}
        </div>

        {/* =================================================
            DASHBOARD
        ================================================= */}

        <div className="mb-10">
          <div className="mb-7">
            <h1 className="text-[27px] font-bold text-center text-[color:var(--ig-t-d1d5db)]">DASHBOARD</h1>

            <div className="w-[120px] h-[3px] bg-[#ff6236] mx-auto mt-2 rounded-full" />
          </div>

          {dashboardEsteiraProposta && (
            <DashboardEsteira
              key={dashboardEsteiraProposta.chave}
              titulo={dashboardEsteiraProposta.titulo}
              etapas={dashboardEsteiraProposta.etapas}
              onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraProposta.chave, etapa.chave)}
            />
          )}

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 xl:gap-10 items-start">
            {dashboardEsteiraFicha && (
              <DashboardEsteira
                key={dashboardEsteiraFicha.chave}
                titulo={dashboardEsteiraFicha.titulo}
                etapas={dashboardEsteiraFicha.etapas}
                onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraFicha.chave, etapa.chave)}
              />
            )}

            {dashboardEsteiraAnalise && (
              <DashboardEsteira
                key={dashboardEsteiraAnalise.chave}
                titulo={dashboardEsteiraAnalise.titulo}
                etapas={dashboardEsteiraAnalise.etapas}
                onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraAnalise.chave, etapa.chave)}
              />
            )}
          </div>

          {dashboardEsteiraAssinaturas && (
            <DashboardEsteira
              key={dashboardEsteiraAssinaturas.chave}
              titulo={dashboardEsteiraAssinaturas.titulo}
              etapas={dashboardEsteiraAssinaturas.etapas}
              onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraAssinaturas.chave, etapa.chave)}
            />
          )}

          {dashboardEsteiraContrato && (
            <DashboardEsteira
              key={dashboardEsteiraContrato.chave}
              titulo={dashboardEsteiraContrato.titulo}
              etapas={dashboardEsteiraContrato.etapas}
              onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraContrato.chave, etapa.chave)}
            />
          )}

          {dashboardEsteiraTemplate && (
            <DashboardEsteira
              key={dashboardEsteiraTemplate.chave}
              titulo={dashboardEsteiraTemplate.titulo}
              etapas={dashboardEsteiraTemplate.etapas}
              onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraTemplate.chave, etapa.chave)}
            />
          )}

          {dashboardEsteiraGeral && (
            <DashboardEsteira
              key={dashboardEsteiraGeral.chave}
              titulo={dashboardEsteiraGeral.titulo}
              etapas={dashboardEsteiraGeral.etapas}
              onEtapaClick={(etapa) => abrirEtapaDashboard(dashboardEsteiraGeral.chave, etapa.chave)}
            />
          )}

          {filtroDashboardSelecionado && (
            <div
              className="
                mt-3
                mb-8
                rounded-lg
                border
                border-[color:var(--ig-b-30394c)]
                bg-[color:var(--ig-f-111625)]
                overflow-hidden
              "
            >
              <div
                className="
                  min-h-[54px]
                  px-5
                  flex
                  items-center
                  justify-between
                  gap-4
                  border-b
                  border-[color:var(--ig-b-30394c)]
                  bg-[color:var(--ig-f-171c2d)]
                "
              >
                <div>
                  <div className="text-[11px] uppercase text-[color:var(--ig-t-6b7280)]">{filtroDashboardSelecionado.processoTitulo}</div>

                  <div className="text-[16px] font-bold text-[color:var(--ig-t-ffffff)]">{filtroDashboardSelecionado.statusTitulo}</div>
                </div>

                <div className="flex items-center gap-4">
                  <span className="text-sm text-[color:var(--ig-t-9ca3af)]">
                    {registrosDashboardFiltrados.length} {registrosDashboardFiltrados.length === 1 ? "registro" : "registros"}
                  </span>

                  <button
                    type="button"
                    onClick={() => setFiltroDashboardSelecionado(null)}
                    className="
                      w-8
                      h-8
                      flex
                      items-center
                      justify-center
                      rounded-md
                      border
                      border-[color:var(--ig-b-3d4658)]
                      text-[color:var(--ig-t-9ca3af)]
                      hover:text-[color:var(--ig-t-ffffff)]
                      hover:bg-[color:var(--ig-f-252c3d)]
                      transition-colors
                    "
                    title="Fechar detalhamento"
                  >
                    <FaTimes size={13} />
                  </button>
                </div>
              </div>

              {registrosDashboardFiltrados.length === 0 ? (
                <div className="py-8 text-center text-sm text-[color:var(--ig-t-6b7280)]">Nenhum registro encontrado nesta etapa.</div>
              ) : filtroDashboardSelecionado.processo === "ASSINATURAS" ? (
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-[color:var(--ig-f-171c2d)] border-b border-[color:var(--ig-b-30394c)]">
                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Assinante</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Papel</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Status</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">Na vez de</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Processo / Documento</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">E-mail</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">
                          Assinado em
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {registrosDashboardFiltrados.map((item) => (
                        <tr
                          key={item.__dashboardChave}
                          onClick={() => abrirRegistroDashboard(item)}
                          className="border-b border-[color:var(--ig-b-252d40)] hover:bg-[color:var(--ig-f-181f31)] transition-colors cursor-pointer"
                          title={`Abrir assinatura ${item.processoTitulo || item.codigo || ""}`}
                        >
                          <td className="px-4 py-3 text-sm font-semibold text-[color:var(--ig-t-ffffff)]">{item.assinanteNome || "—"}</td>

                          <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)]">{item.assinantePapel || "—"}</td>

                          <td className="px-4 py-3 text-sm font-semibold text-[color:var(--ig-t-e5e7eb)] whitespace-nowrap">
                            {item.__assinaturaStatusNome || "—"}
                          </td>

                          <td className="px-4 py-3 text-sm">{celulaNaVezDe(item)}</td>

                          <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)]">{item.processoTitulo || item.codigo || "—"}</td>

                          <td className="px-4 py-3 text-sm text-[color:var(--ig-t-9ca3af)]">{item.assinanteEmail || "—"}</td>

                          <td className="px-4 py-3 text-sm text-[color:var(--ig-t-9ca3af)] whitespace-nowrap">
                            {item.assinadoEm ? formatarDataHora(item.assinadoEm) : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-[color:var(--ig-f-171c2d)] border-b border-[color:var(--ig-b-30394c)]">
                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">
                          {filtroDashboardSelecionado.processo === "TEMPLATE" ? "Template" : "Código"}
                        </th>

                        {filtroDashboardSelecionado.processo === "GERAL" && (
                          <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">
                            Processo
                          </th>
                        )}

                        {filtroDashboardSelecionado.processo === "TEMPLATE" ? (
                          <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">
                            Enviado em
                          </th>
                        ) : (
                          <>
                            <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Imóvel</th>

                            <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Locatária</th>
                          </>
                        )}

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)]">Situação</th>

                        <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase text-[color:var(--ig-t-6b7280)] whitespace-nowrap">Na vez de</th>
                      </tr>
                    </thead>

                    <tbody>
                      {registrosDashboardFiltrados.map((item) => (
                        <tr
                          key={item.__dashboardChave || `${filtroDashboardSelecionado.processo}-${item.id}`}
                          onClick={() => abrirRegistroDashboard(item)}
                          className="
                              border-b
                              border-[color:var(--ig-b-252d40)]
                              hover:bg-[color:var(--ig-f-181f31)]
                              transition-colors
                              cursor-pointer
                            "
                          title={`Abrir ${item.__dashboardProcessoTitulo || filtroDashboardSelecionado.processoTitulo} ${item.codigo || `PC${item.id}`}`}
                        >
                          <td className="px-4 py-3 text-sm font-bold text-[color:var(--ig-t-ffffff)] whitespace-nowrap">{item.codigo || `PC${item.id}`}</td>

                          {filtroDashboardSelecionado.processo === "GERAL" && (
                            <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)] whitespace-nowrap">{item.__dashboardProcessoTitulo || "—"}</td>
                          )}

                          {filtroDashboardSelecionado.processo === "TEMPLATE" ? (
                            <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)] whitespace-nowrap">
                              {item.dataUpload ? formatarDataHora(item.dataUpload) : "—"}
                            </td>
                          ) : (
                            <>
                              <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)]">
                                {item.__dashboardProcessoOrigem === "TEMPLATE" ? "—" : imovelDashboard(item)}
                              </td>

                              <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)]">
                                {item.__dashboardProcessoOrigem === "TEMPLATE" ? "—" : nomeLocatariaDashboard(item)}
                              </td>
                            </>
                          )}

                          <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)] whitespace-nowrap">
                            {item.__dashboardSituacao || filtroDashboardSelecionado.statusTitulo}
                          </td>

                          <td className="px-4 py-3 text-sm">{celulaNaVezDe(item)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>

        {/* =================================================
            CENTRAL DE INTERAÇÕES
        ================================================= */}

        <div id="central-interacoes-secao" className="flex items-start justify-between gap-6 mb-4 flex-wrap scroll-mt-5">
          <div>
            <h1 className="text-[22px] font-bold leading-tight text-[color:var(--ig-t-ffffff)]">Central de Interações</h1>

            <p className="text-sm text-[color:var(--ig-t-9ca3af)] mt-1">Acompanhe os processos que dependem da sua interação para seguir.</p>
          </div>

          <div className="ml-auto flex flex-col items-end gap-3">
            <div className="flex items-center justify-end gap-4 flex-wrap">
              <div className="flex items-center justify-end gap-4 flex-wrap">
                {LEGENDA_SITUACOES.map((item) => (
                  <div key={item.nome} className="flex items-center gap-1.5">
                    <span
                      className={`
                        w-[9px]
                        h-[9px]
                        rounded-full
                        ${item.classe}
                      `}
                    />

                    <span className="text-[11px] text-[color:var(--ig-t-9ca3af)] whitespace-nowrap">{item.nome}</span>
                  </div>
                ))}
              </div>

              <button
                type="button"
                onClick={() => rolarParaSecao("dashboard-home-topo")}
                className="
                  w-9
                  h-9
                  flex
                  items-center
                  justify-center
                  rounded-md
                  border
                  border-[color:var(--ig-b-30394c)]
                  bg-[color:var(--ig-f-171d2c)]
                  text-[color:var(--ig-t-d1d5db)]
                  hover:text-[#2196f3]
                  hover:border-[#2196f3]
                  hover:bg-[#2196f3]/10
                  transition-colors
                "
                title="Voltar ao Dashboard"
              >
                <FaChevronUp size={15} />
              </button>
            </div>

            <button
              type="button"
              onClick={() => alterarVisao(visaoSelecionada === "HISTORICOS" ? "PENDENCIAS" : "HISTORICOS")}
              className={`
                h-[38px]
                px-4
                flex
                items-center
                justify-center
                gap-2
                rounded-md
                border
                text-sm
                font-semibold
                whitespace-nowrap
                transition-colors
                ${
                  visaoSelecionada === "HISTORICOS"
                    ? `
                        bg-[#3d111f]
                        border-[#6e243a]
                        text-[#ffdbe5]
                        hover:bg-[#481522]
                      `
                    : `
                        bg-[#7a2942]
                        border-[#a34765]
                        text-white
                        hover:bg-[#8b314d]
                        hover:border-[#b95674]
                      `
                }
              `}
              title={visaoSelecionada === "HISTORICOS" ? "Voltar para as pendências" : "Consultar históricos"}
            >
              <FaHistory size={14} />
              Históricos
            </button>
          </div>
        </div>

        {/* ASSINATURAS */}

        <button
          type="button"
          onClick={() => alterarVisao(visaoSelecionada === "ASSINATURAS" ? "PENDENCIAS" : "ASSINATURAS")}
          className={`
            h-[38px]
            px-4
            flex
            items-center
            justify-center
            gap-2
            rounded-md
            border
            text-sm
            font-semibold
            whitespace-nowrap
            transition-colors
            ${
              visaoSelecionada === "ASSINATURAS"
                ? `
                    bg-[#123b5a]
                    border-[#1d6594]
                    text-[#d8efff]
                    hover:bg-[#17486d]
                  `
                : `
                    bg-[#14618d]
                    border-[#2380b8]
                    text-white
                    hover:bg-[#1973a5]
                    hover:border-[#2b91cb]
                  `
            }
          `}
          title={visaoSelecionada === "ASSINATURAS" ? "Voltar para as pendências" : "Consultar assinaturas"}
        >
          <FaFileSignature size={14} />
          Assinaturas
        </button>

        {/* =================================================
            CATEGORIAS
        ================================================= */}

        <div className="flex items-center gap-2 overflow-x-auto pb-1 mb-4">
          {categoriasVisaoAtual.map((categoria) => {
            const ativo = categoriaSelecionada === categoria.chave;

            const Icone = categoria.Icone;

            const estiloAtivo = estiloCategoriaAtiva(categoria.chave);

            return (
              <button
                key={categoria.chave}
                type="button"
                onClick={() => setCategoriaSelecionada(categoria.chave)}
                className={`
                    flex
                    items-center
                    justify-center
                    gap-2
                    min-h-[42px]
                    px-4
                    rounded-lg
                    whitespace-nowrap
                    text-sm
                    font-semibold
                    border
                    transition-all
                    ${ativo ? estiloAtivo.botao : "bg-transparent border-transparent text-[color:var(--ig-t-9ca3af)] hover:bg-[color:var(--ig-f-171d2c)] hover:text-[color:var(--ig-t-e5e7eb)]"}
                  `}
              >
                <Icone size={13} />

                <span>{categoria.nome}</span>

                <span
                  className={`
                      min-w-[22px]
                      h-[22px]
                      px-1.5
                      rounded-full
                      flex
                      items-center
                      justify-center
                      text-[11px]
                      font-bold
                      ${ativo ? estiloAtivo.contador : "bg-[color:var(--ig-f-202738)] text-[color:var(--ig-t-d1d5db)]"}
                    `}
                >
                  {categoria.quantidade}
                </span>
              </button>
            );
          })}
        </div>

        {/* =================================================
            FILTROS + AÇÕES
        ================================================= */}

        <div className="mb-3">
          <div className="flex items-end gap-3 flex-wrap mb-3">
            <fieldset
              className="
                h-[46px]
                flex-1
                min-w-[320px]
                px-3
                rounded-md
                border
                border-[color:var(--ig-b-4b5568)]
                bg-[color:var(--ig-f-111625)]
              "
            >
              <legend className="px-1 text-[11px] text-[color:var(--ig-t-d1d5db)] leading-none">Pesquisar</legend>

              <div className="relative h-[30px] -mt-[1px]">
                <FaSearch
                  size={13}
                  className="
                    absolute
                    left-0
                    top-1/2
                    -translate-y-1/2
                    text-[color:var(--ig-t-9ca3af)]
                    pointer-events-none
                  "
                />

                <input
                  type="text"
                  value={filtroPesquisa}
                  onChange={(e) => setFiltroPesquisa(e.target.value)}
                  placeholder="Código, processo, imóvel, locatário..."
                  className="
                    w-full
                    h-[30px]
                    pl-6
                    pr-2
                    bg-transparent
                    text-[color:var(--ig-t-e5e7eb)]
                    placeholder-gray-600
                    text-sm
                    outline-none
                  "
                />
              </div>
            </fieldset>

            <button
              type="button"
              onClick={limparFiltros}
              className="
                h-[40px]
                px-4
                flex
                items-center
                justify-center
                rounded-md
                border
                border-[#2196f3]
                bg-transparent
                text-[#2196f3]
                text-sm
                font-semibold
                whitespace-nowrap
                hover:bg-[#2196f3]/10
                transition-colors
              "
            >
              Limpar Filtro
            </button>

            <button
              type="button"
              onClick={copiarTabela}
              className="
                h-[40px]
                px-4
                flex
                items-center
                justify-center
                gap-2
                rounded-md
                border
                border-[#2196f3]
                bg-[#2196f3]
                hover:bg-[#1e88e5]
                text-white
                text-sm
                font-semibold
                whitespace-nowrap
                transition-colors
              "
            >
              <FaCopy size={13} />
              Copiar
            </button>

            <button
              type="button"
              onClick={exportarCsv}
              className="
                h-[40px]
                px-5
                flex
                items-center
                justify-center
                rounded-md
                border
                border-[#2196f3]
                bg-[#2196f3]
                hover:bg-[#1e88e5]
                text-white
                text-sm
                font-semibold
                whitespace-nowrap
                transition-colors
              "
            >
              CSV
            </button>
          </div>

          <div className="flex items-end gap-3 flex-wrap">
            <FiltroSelect
              rotulo="Situação"
              valor={filtroSituacao}
              placeholder="Todas as situações"
              opcoes={
                visaoSelecionada === "HISTORICOS" ? SITUACOES_HISTORICOS : visaoSelecionada === "ASSINATURAS" ? SITUACOES_ASSINATURAS : SITUACOES_DISPONIVEIS
              }
              onChange={setFiltroSituacao}
              className="w-[250px]"
            />

            <FiltroSelect
              rotulo="Processo"
              valor={filtroProcesso}
              placeholder="Todos os processos"
              opcoes={PROCESSOS_DISPONIVEIS}
              onChange={setFiltroProcesso}
              className="w-[300px]"
            />

            <fieldset
              className="
                h-[46px]
                w-[180px]
                px-3
                rounded-md
                border
                border-[color:var(--ig-b-4b5568)]
                bg-[color:var(--ig-f-111625)]
              "
            >
              <legend className="px-1 text-[11px] text-[color:var(--ig-t-d1d5db)] leading-none">DE</legend>

              <input
                type="date"
                value={dataInicial}
                onChange={(e) => setDataInicial(e.target.value)}
                className="
                  w-full
                  h-[30px]
                  -mt-[1px]
                  bg-transparent
                  text-[color:var(--ig-t-ffffff)]
                  text-sm
                  outline-none
                  cursor-pointer
                "
                style={{
                  colorScheme: "var(--ig-e-1txfa)",
                }}
              />
            </fieldset>

            <fieldset
              className="
                h-[46px]
                w-[180px]
                px-3
                rounded-md
                border
                border-[color:var(--ig-b-4b5568)]
                bg-[color:var(--ig-f-111625)]
              "
            >
              <legend className="px-1 text-[11px] text-[color:var(--ig-t-d1d5db)] leading-none">ATÉ</legend>

              <input
                type="date"
                value={dataFinal}
                onChange={(e) => setDataFinal(e.target.value)}
                className="
                  w-full
                  h-[30px]
                  -mt-[1px]
                  bg-transparent
                  text-[color:var(--ig-t-ffffff)]
                  text-sm
                  outline-none
                  cursor-pointer
                "
                style={{
                  colorScheme: "var(--ig-e-1txfa)",
                }}
              />
            </fieldset>

            <span className="text-xs text-[color:var(--ig-t-6b7280)] mb-[14px]">
              {pendenciasFiltradas.length} {pendenciasFiltradas.length === 1 ? "registro" : "registros"}
            </span>

            <div className="ml-auto">
              <button
                type="button"
                onClick={() => setRegistrosExpandidos((valorAtual) => !valorAtual)}
                className={`
                  h-[23px]
                  min-w-[118px]
                  px-2
                  flex
                  items-center
                  justify-center
                  gap-2
                  rounded-md
                  border-2
                  bg-transparent
                  text-sm
                  font-semibold
                  whitespace-nowrap
                  transition-colors
                  ${registrosExpandidos ? "border-red-500 text-red-500 hover:bg-red-500/10" : "border-cyan-500 text-cyan-500 hover:bg-cyan-500/10"}
                `}
              >
                {registrosExpandidos ? (
                  <>
                    <FaChevronDown size={10} />
                    Minimizar
                  </>
                ) : (
                  <>
                    <FaChevronUp size={10} />
                    Expandir
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* =================================================
            TABELA
        ================================================= */}

        {registrosExpandidos && (
          <>
            {loading && pendencias.length === 0 ? (
              <div className="py-16 flex flex-col items-center justify-center">
                <FaSyncAlt size={25} className="text-[#2196f3] animate-spin mb-4" />

                <p className="text-sm text-[color:var(--ig-t-9ca3af)]">Carregando interações...</p>
              </div>
            ) : mensagemErro ? (
              <div className="py-16 flex flex-col items-center justify-center text-center">
                <FaExclamationTriangle size={28} className="text-red-500 mb-4" />

                <p className="text-sm font-semibold text-[color:var(--ig-t-e5e7eb)]">Não foi possível carregar a Central de Interações.</p>

                <p className="text-xs text-[color:var(--ig-t-6b7280)] mt-1">{mensagemErro}</p>

                {(!usandoDadosExternos || typeof onAtualizar === "function") && (
                  <button
                    type="button"
                    onClick={atualizarCentral}
                    disabled={loading}
                    className="
                      mt-5
                      h-9
                      px-4
                      flex
                      items-center
                      justify-center
                      gap-2
                      rounded-md
                      border
                      border-[#2196f3]
                      bg-transparent
                      text-[#2196f3]
                      text-xs
                      font-semibold
                      hover:bg-[#2196f3]/10
                      disabled:opacity-50
                      disabled:cursor-not-allowed
                      transition-colors
                    "
                  >
                    <FaSyncAlt size={11} className={loading ? "animate-spin" : ""} />
                    Tentar novamente
                  </button>
                )}
              </div>
            ) : pendenciasFiltradas.length === 0 ? (
              <div className="py-14 text-center">
                <FaBell size={24} className="mx-auto mb-3 text-gray-600" />

                <p className="text-sm text-[color:var(--ig-t-9ca3af)]">
                  {visaoSelecionada === "ASSINATURAS" ? "Nenhuma assinatura encontrada." : "Nenhuma interação encontrada."}
                </p>
              </div>
            ) : (
              <div className="bg-transparent overflow-visible">
                <div
                  className="
                    border-t
                    border-l
                    border-r
                    border-[color:var(--ig-b-293246)]
                    rounded-t-lg
                    bg-transparent
                    overflow-x-auto
                  "
                >
                  <table
                    className="w-full border-collapse table-fixed"
                    style={{
                      width: "100%",
                      minWidth: `${larguraTotalGrid}px`,
                    }}
                  >
                    <colgroup>
                      {ordemColunas.map((chave) => {
                        const coluna = COLUNAS_CENTRAL_MAPA[chave];

                        const largura = largurasColunas[chave] || coluna?.largura || 100;

                        return (
                          <col
                            key={chave}
                            style={{
                              width: `${largura}px`,
                            }}
                          />
                        );
                      })}

                      <col />
                    </colgroup>

                    <thead>
                      <tr className="bg-[color:var(--ig-f-171c2d)] border-b border-[color:var(--ig-b-30394c)]">
                        {ordemColunas.map((chave) => renderizarCabecalhoColuna(chave))}

                        <th aria-hidden="true" className="p-0 bg-[color:var(--ig-f-171c2d)]" />
                      </tr>
                    </thead>

                    <tbody>
                      {pendenciasPaginadas.map((pendencia, index) => {
                        const podeAbrir = temDestinoValido(pendencia);

                        const indicador = estadoVisualRegistro(pendencia);

                        return (
                          <tr
                            key={pendencia?.chave || `${chaveInteracao(pendencia)}-${index}`}
                            onClick={podeAbrir ? () => abrirPendencia(pendencia) : undefined}
                            className={`
                                border-b
                                border-[color:var(--ig-b-252d40)]
                                transition-colors
                                ${indicador.linha}
                                ${podeAbrir ? "cursor-pointer" : ""}
                              `}
                          >
                            {ordemColunas.map((chave) => renderizarCelulaColuna(chave, pendencia))}

                            <td aria-hidden="true" className="p-0" />
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* PAGINAÇÃO */}

                <div
                  className="
                    min-h-[52px]
                    px-4
                    flex
                    items-center
                    justify-end
                    gap-8
                    bg-transparent
                    text-sm
                    text-[color:var(--ig-t-ffffff)]
                  "
                >
                  <div className="relative flex items-center gap-3">
                    <span className="whitespace-nowrap">Registros por página:</span>

                    <button
                      type="button"
                      onClick={() => setSeletorPaginaAberto((valorAtual) => !valorAtual)}
                      className="
                        min-w-[52px]
                        h-[34px]
                        px-3
                        flex
                        items-center
                        justify-between
                        gap-3
                        bg-transparent
                        text-[color:var(--ig-t-ffffff)]
                        rounded-md
                        hover:bg-[color:var(--ig-f-171d2c)]
                        transition-colors
                      "
                    >
                      <span>{registrosPorPagina}</span>

                      <FaChevronDown
                        size={11}
                        className={`
                          transition-transform
                          ${seletorPaginaAberto ? "rotate-180" : ""}
                        `}
                      />
                    </button>

                    {seletorPaginaAberto && (
                      <div
                        className="
                          absolute
                          z-[150]
                          top-[38px]
                          right-0
                          min-w-[60px]
                          overflow-hidden
                          rounded-md
                          bg-[color:var(--ig-f-2b2b2b)]
                          shadow-xl
                        "
                      >
                        {[5, 10, 25].map((quantidade) => (
                          <button
                            key={quantidade}
                            type="button"
                            onClick={() => alterarRegistrosPorPagina(quantidade)}
                            className={`
                                w-full
                                h-[42px]
                                px-4
                                flex
                                items-center
                                justify-center
                                text-sm
                                transition-colors
                                ${registrosPorPagina === quantidade ? "bg-[#294154] text-white" : "bg-[color:var(--ig-f-2b2b2b)] text-[color:var(--ig-t-ffffff)] hover:bg-[color:var(--ig-f-363636)]"}
                              `}
                          >
                            {quantidade}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <span className="min-w-[90px] text-center whitespace-nowrap">{`${indiceInicial + 1}–${indiceFinal} de ${totalRegistros}`}</span>

                  <button
                    type="button"
                    onClick={paginaAnterior}
                    disabled={paginaSegura <= 1}
                    className="
                      w-8
                      h-8
                      flex
                      items-center
                      justify-center
                      text-[color:var(--ig-t-ffffff)]
                      disabled:text-gray-600
                      disabled:cursor-not-allowed
                      hover:text-[#2196f3]
                      disabled:hover:text-gray-600
                      transition-colors
                    "
                    title="Página anterior"
                  >
                    <FaChevronUp size={15} className="-rotate-90" />
                  </button>

                  <button
                    type="button"
                    onClick={proximaPagina}
                    disabled={paginaSegura >= totalPaginas}
                    className="
                      w-8
                      h-8
                      flex
                      items-center
                      justify-center
                      text-[color:var(--ig-t-ffffff)]
                      disabled:text-gray-600
                      disabled:cursor-not-allowed
                      hover:text-[#2196f3]
                      disabled:hover:text-gray-600
                      transition-colors
                    "
                    title="Próxima página"
                  >
                    <FaChevronUp size={15} className="rotate-90" />
                  </button>
                </div>
              </div>
            )}
          </>
        )}

        {/* =================================================
            ATIVIDADE DE APROVADORES
        ================================================= */}

        {usuarioAdministrador && (
          <div
            className="
              mt-10
              mb-8
              rounded-lg
              border
              border-[color:var(--ig-b-30394c)]
              bg-[color:var(--ig-f-111625)]
              overflow-hidden
            "
          >
            <div
              className="
                min-h-[58px]
                px-5
                flex
                items-center
                justify-between
                gap-4
                border-b
                border-[color:var(--ig-b-30394c)]
                bg-[color:var(--ig-f-171c2d)]
              "
            >
              <div className="flex items-center gap-3">
                <FaUserCheck size={18} className="text-[#2196f3]" />

                <div>
                  <h3 className="text-[18px] font-bold text-[color:var(--ig-t-ffffff)]">ATIVIDADE DE APROVADORES</h3>

                  <p className="text-xs text-[color:var(--ig-t-6b7280)] mt-0.5">
                    Pendências paradas por usuário (aprovações, questionamentos, assinaturas e andamentos) e último acesso à HOME
                  </p>
                </div>
              </div>
            </div>

            {loadingAprovadoresDashboard ? (
              <div
                className="
                  py-10
                  flex
                  items-center
                  justify-center
                  gap-3
                "
              >
                <FaSyncAlt size={15} className="text-[#2196f3] animate-spin" />

                <span className="text-sm text-[color:var(--ig-t-9ca3af)]">Carregando atividade dos aprovadores...</span>
              </div>
            ) : usuariosAprovadoresDashboard.length === 0 ? (
              <div
                className="
                  py-10
                  text-center
                  text-sm
                  text-[color:var(--ig-t-6b7280)]
                "
              >
                Nenhuma atividade de aprovador encontrada.
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr
                      className="
                        bg-[color:var(--ig-f-171c2d)]
                        border-b
                        border-[color:var(--ig-b-30394c)]
                      "
                    >
                      <th
                        className="
                          w-[32%]
                          px-4
                          py-3
                          text-left
                          text-[12px]
                          font-bold
                          uppercase
                          text-[color:var(--ig-t-d1d5db)]
                        "
                      >
                        Usuário
                      </th>

                      <th
                        className="
                          w-[10%]
                          px-4
                          py-3
                          text-left
                          text-[12px]
                          font-bold
                          uppercase
                          text-[color:var(--ig-t-d1d5db)]
                        "
                      >
                        Tipo
                      </th>

                      <th
                        className="
                          w-[12%]
                          px-4
                          py-3
                          text-center
                          text-[12px]
                          font-bold
                          uppercase
                          text-[color:var(--ig-t-d1d5db)]
                          whitespace-nowrap
                        "
                      >
                        Qtde.
                      </th>

                      <th
                        className="
                          w-[22%]
                          px-4
                          py-3
                          text-left
                          text-[12px]
                          font-bold
                          uppercase
                          text-[color:var(--ig-t-d1d5db)]
                          whitespace-nowrap
                        "
                      >
                        Último acesso
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {usuariosAprovadoresPaginados.flatMap((usuario, usuarioIndex) => {
                      const acoes = acoesParadasAprovador(usuario);

                      const linhas =
                        acoes.length > 0
                          ? acoes
                          : [
                              {
                                tipo: "—",
                                quantidade: 0,
                              },
                            ];

                      return linhas.map((acao, acaoIndex) => {
                        const primeiraLinha = acaoIndex === 0;

                        return (
                          <tr
                            key={`${usuario?.usuarioId || usuario?.id || usuarioIndex}-${acaoIndex}`}
                            className={`
                                  border-b
                                  border-[color:var(--ig-b-30394c)]
                                  hover:bg-[color:var(--ig-f-181f31)]
                                  transition-colors
                                  ${primeiraLinha && usuarioIndex > 0 ? "border-t-2 border-t-[color:var(--ig-b-4b5568)]" : ""}
                                `}
                          >
                            <td className="px-4 py-3 text-sm text-[color:var(--ig-t-e5e7eb)]">{primeiraLinha ? nomeAprovadorDashboard(usuario) : ""}</td>

                            <td className="px-4 py-3">
                              {acao?.tipo && acao.tipo !== "—" ? (
                                <div
                                  className="
                                        flex
                                        items-center
                                        gap-2
                                        min-h-[28px]
                                      "
                                >
                                  <span
                                    className="
                                          w-[7px]
                                          h-[7px]
                                          rounded-full
                                          bg-[#3b82f6]
                                          flex-shrink-0
                                        "
                                  />

                                  <span
                                    className="
                                          text-[13px]
                                          font-medium
                                          text-[color:var(--ig-t-e5e7eb)]
                                          whitespace-nowrap
                                        "
                                  >
                                    {acao.tipo}
                                  </span>
                                </div>
                              ) : (
                                <span className="text-sm text-gray-600">—</span>
                              )}
                            </td>

                            <td className="px-4 py-3 text-center text-sm font-semibold text-[color:var(--ig-t-e5e7eb)]">{Number(acao?.quantidade || 0)}</td>

                            <td className="px-4 py-3 text-sm text-[color:var(--ig-t-d1d5db)] whitespace-nowrap">
                              {primeiraLinha ? formatarUltimoAcessoAprovador(ultimoAcessoAprovador(usuario)) : ""}
                            </td>
                          </tr>
                        );
                      });
                    })}
                  </tbody>
                </table>

                <div
                  className="
                    min-h-[52px]
                    px-4
                    flex
                    items-center
                    justify-end
                    gap-8
                    border-t
                    border-[color:var(--ig-b-30394c)]
                    bg-[color:var(--ig-f-171c2d)]
                    text-sm
                    text-[color:var(--ig-t-ffffff)]
                  "
                >
                  <div className="relative flex items-center gap-3">
                    <span className="whitespace-nowrap">Registros por página:</span>

                    <button
                      type="button"
                      onClick={() => setSeletorAprovadoresPaginaAberto((valorAtual) => !valorAtual)}
                      className="
                        min-w-[52px]
                        h-[34px]
                        px-3
                        flex
                        items-center
                        justify-between
                        gap-3
                        bg-transparent
                        text-[color:var(--ig-t-ffffff)]
                        rounded-md
                        hover:bg-[color:var(--ig-f-202738)]
                        transition-colors
                      "
                    >
                      <span>{aprovadoresPorPagina}</span>

                      <FaChevronDown
                        size={11}
                        className={`
                          transition-transform
                          ${seletorAprovadoresPaginaAberto ? "rotate-180" : ""}
                        `}
                      />
                    </button>

                    {seletorAprovadoresPaginaAberto && (
                      <div
                        className="
                          absolute
                          z-[150]
                          bottom-[38px]
                          right-0
                          min-w-[60px]
                          overflow-hidden
                          rounded-md
                          bg-[color:var(--ig-f-2b2b2b)]
                          shadow-xl
                        "
                      >
                        {[5, 10, 25].map((quantidade) => (
                          <button
                            key={quantidade}
                            type="button"
                            onClick={() => alterarAprovadoresPorPagina(quantidade)}
                            className={`
                                w-full
                                h-[42px]
                                px-4
                                flex
                                items-center
                                justify-center
                                text-sm
                                transition-colors
                                ${aprovadoresPorPagina === quantidade ? "bg-[#294154] text-white" : "bg-[color:var(--ig-f-2b2b2b)] text-[color:var(--ig-t-ffffff)] hover:bg-[color:var(--ig-f-363636)]"}
                              `}
                          >
                            {quantidade}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <span className="min-w-[90px] text-center whitespace-nowrap">
                    {totalAprovadores === 0 ? "0–0 de 0" : `${indiceInicialAprovadores + 1}–${indiceFinalAprovadores} de ${totalAprovadores}`}
                  </span>

                  <button
                    type="button"
                    onClick={paginaAnteriorAprovadores}
                    disabled={paginaAprovadoresSegura <= 1}
                    className="
                      w-8
                      h-8
                      flex
                      items-center
                      justify-center
                      text-[color:var(--ig-t-ffffff)]
                      disabled:text-gray-600
                      disabled:cursor-not-allowed
                      hover:text-[#2196f3]
                      disabled:hover:text-gray-600
                      transition-colors
                    "
                    title="Página anterior"
                  >
                    <FaChevronUp size={15} className="-rotate-90" />
                  </button>

                  <button
                    type="button"
                    onClick={proximaPaginaAprovadores}
                    disabled={paginaAprovadoresSegura >= totalPaginasAprovadores}
                    className="
                      w-8
                      h-8
                      flex
                      items-center
                      justify-center
                      text-[color:var(--ig-t-ffffff)]
                      disabled:text-gray-600
                      disabled:cursor-not-allowed
                      hover:text-[#2196f3]
                      disabled:hover:text-gray-600
                      transition-colors
                    "
                    title="Próxima página"
                  >
                    <FaChevronUp size={15} className="rotate-90" />
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {modoOverlay && (
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onFechar}
              className="
                px-5
                py-2
                rounded-md
                bg-gray-600
                hover:bg-gray-700
                text-white
                text-xs
                font-semibold
              "
            >
              Fechar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CentralInteracao;
